<template>
	<div class="d-flex j-center">
		<div>
			<div style="height: 60px;font-size: 12px;font-weight: 600;justify-content: flex-end;" class="d-flex a-center">
				<el-button @click="admin_save_bu_zxb_info()" style="background-color: #1E69FF;" size="mini" type="primary">发布
				</el-button>
				<el-button @click="setColor=true" style="margin-left: 24px;" size="mini" type="primary">设置字体/背景色
				</el-button>
			</div>
			<section v-show="tabIndex==0" class="decoration-edit">
				<section class="l">
					<div style="height: 60px;box-sizing: border-box;padding: 0 12px;" class="d-flex a-center">
						<div>
							<div style="font-size: 16px;font-weight: 600;">企业装修</div>
							<div style="font-size: 12px;color: #888888;">拖动到页面中间的画布区域进行布局</div>
						</div>
					</div>
					<ul @dragstart="dragStart" @dragend="dragEnd">
						<li @click="val.isopen=!val.isopen" v-for="(val, key, index) in typeList" draggable
							:data-type="key" :key="index + 1">
							<p>{{val.name}}</p>
							<img v-if="val.isopen"  style="width: 12px;height: 12px;margin-left: auto;transform: rotate(90deg);"
								src="../../assets/brand_fixtures/heng.png" />
							<img v-else style="width: 12px;height: 12px;margin-left: auto;"
								src="../../assets/brand_fixtures/heng.png" />
							<div v-if="val.isopen" style="width: 100%;margin-top: 25px;margin-bottom: 25px;">
								<div style="width: 130px;height: 130px;background: #F5F5F5;border-radius: 5px;"
									class="d-flex a-center j-center">
									<div style="width: 112px;height: 112px;background-size: 100% auto;"
										:style="'background-image: url('+val.img+')'"></div>
								</div>
							</div>
						</li>
					</ul>
				</section>
				<section class="c">
					<!-- header 不可拖拽 -->
					<div class="top-nav">
						<img src="../../assets/images/topNavBlack.png">
						<span class="tit">页面标题</span>
					</div>
					<div class="view-content" @drop="drog" @dragover="dragOver"
						:style="{ backgroundColor: colour_code }">
						<Draggable v-model="view" draggable=".item">
							<template v-for="(item, index) in view">
								<div :data-index="index" :key="index" class="item" @click="selectType(index)">
									<!-- waiting -->
									<template v-if="item.status && item.status == 2">
										<div class="wait"> {{ item.type }} </div>
									</template>
									<template v-else>
										<component :is="typeList[item.type]['com']" :data="item"
											:className="className[item.tabType]"></component>
									</template>
									<i @click.stop="deleteItem($event, index)" class="el-icon-error"></i>
								</div>
							</template>
						</Draggable>
					</div>
				</section>
				<section class="r">
					<EditForm @setIndex="setIndex" :background="background" :data="props" v-if="isRight"></EditForm>
				</section>
			</section>
		</div>
		<el-dialog
		  title="提示"
		  :visible.sync="txtShow"
		  width="30%"
		  top="30vh">
		  <input v-model="txt" style="width: 100%;height: 30px;box-sizing: border-box;padding: 0 6px;" placeholder="请输入内容" />
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="txtShow=false" size="small" >取 消</el-button>
		    <el-button @click="setTxt()" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  :modal="true"
		  :visible.sync="alState"
		  width="1170px"
		  top="5vh"
		  :show-close="true"
		  :close-on-press-escape="false"
		  :close-on-click-modal	="false">
			  <slot name="title">
			  </slot>
			  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
					<div style="padding-bottom: 7px;cursor: pointer;margin-left: 15px;border-bottom: 2px solid #226CFF;color:#226CFF">
					添加案例
					</div>
			  </div>
			  <div style="height: 630px;padding: 0 24px;box-sizing: border-box;overflow-y: scroll;">
					<el-input placeholder="请输入内容" v-model="keyword" style="width: 280px;margin: 21px 0;" size="small">
					  <el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
					<div class="goods-box" style="display: flex;justify-content: space-between;flex-wrap: wrap;">
					  <div v-for="(item,index) in cgalList" :key="index" @click="setGoods(item)" style="cursor: pointer;margin-bottom: 20px;" class="d-flex a-center">
						  <img v-if="item.checked" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/xuanzhong.png" />
						  <img v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/moren.png" />
						  <img style="width: 60px;height: 60px;margin-left: 9px;" :src="item.cover" />
						  <div style="display: flex;height: 60px;justify-content: space-between;flex-direction: column;
						  color: #666666;font-size: 12px;margin-left: 11px;width: 210px;">
							  <div class="text-hide-2">{{item.title}}</div>
						  </div>
					  </div>
					</div>
			  </div>
			  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				  <div style="font-size: 12px;color: #888888;">*选择需要展示的案例</div>
				  <div class="d-flex a-center" style="margin-left: auto;">
					  <el-button @click="alState=false" size="mini">取消</el-button>
					  <el-button  @click="alState=false" type="primary" size="mini">确定</el-button>
				  </div>
			  </div>
		  </el-dialog>
		  <el-dialog
		    :modal="true"
		    :visible.sync="tgState"
		    width="1170px"
		    top="5vh"
		    :show-close="true"
		    :close-on-press-escape="false"
		    :close-on-click-modal	="false">
		  	  <slot name="title">
		  	  </slot>
		  	  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
		  			<div style="padding-bottom: 7px;cursor: pointer;border-bottom: 2px solid #226CFF;color:#226CFF">
		  			创建推广
		  			</div>
		  	  </div>
		  	  <div class="tg-box" style="height: 630px;padding: 0px;box-sizing: border-box;overflow-y: scroll;">
		  			<template v-if="add_type==1">
						<div class="d-flex a-center" style="font-size: 14px;font-weight: 600;margin-top: 15px;">
							推广人员
							<div @click="sel_tgy_state=true" style="margin-left: 105px;color: #1E69FF;cursor: pointer;font-weight: 500;">+添加</div>
						</div>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for="(item,index) in sel_tgy_list" :key="index" v-if="item.checked" class="d-flex a-center"
							style="background: #F8F8F8;border-radius: 2px;padding: 3px 13px;
							margin-top: 14px;margin-right: 24px;cursor: pointer;">
								<div style="font-size: 14px;">{{item.name}}</div>
								<img @click="item.checked = false" style="width: 14px;height: 14px;margin-left: 14px;" src="../../assets/brand_fixtures/shandiao.png" />
							</div>
						</div>
						<!-- <div class="d-flex a-center" style="margin-top: 11px;">
							<div class="d-flex a-center">
								<div style="font-size: 12px;color: #888888;">推广人姓名</div>
								<el-input v-model="name" size="mini" style="width: 120px;margin-left: 12px;" placeholder="请输入"></el-input>
							</div>
							<div style="margin-left: 41px;" class="d-flex a-center">
								<div style="font-size: 12px;color: #888888;">电话</div>
								<el-input v-model="mobile" size="mini" style="width: 120px;margin-left: 12px;" placeholder="请输入"></el-input>
							</div>
							<div style="margin-left: 41px;" class="d-flex a-center">
								<div style="font-size: 12px;color: #888888;">微信绑定号码</div>
								<el-input v-model="micro_mobile" size="mini" style="width: 120px;margin-left: 12px;" placeholder="请输入"></el-input>
							</div>
							<div style="margin-left: 41px;" class="d-flex a-center">
								<div style="font-size: 12px;color: #888888;">推广地区</div>
								<el-input v-model="region" size="mini" style="width: 120px;margin-left: 12px;" placeholder="如：深圳宝安"></el-input>
							</div>
						</div> -->
					</template>
					
					<div style="font-size: 14px;font-weight: 700;margin-top: 30px;">
						推广信息
					</div>
					<div class="d-flex a-center" style="margin-top: 11px;">
						<div @click="spread_type=0" class="d-flex a-center" style="cursor: pointer;">
							<img v-if="spread_type==0" src="../../assets/brand_fixtures/xuanzhong.png" />
							<img v-else src="../../assets/brand_fixtures/moren.png" />
							<div style="font-size: 14px;margin-left: 9px;">整体企业推广</div>
						</div>
						<div @click="spread_type=1" class="d-flex a-center" style="margin-left: 50px;cursor: pointer;">
							<img v-if="spread_type==1" src="../../assets/brand_fixtures/xuanzhong.png" />
							<img v-else src="../../assets/brand_fixtures/moren.png" />
							<div style="font-size: 14px;margin-left: 9px;">特定推广</div>
						</div>
					</div>
					<template v-if="spread_type == 0">
						<div  style="display: flex;margin-top: 30px;">
							<div class="d-flex a-center"
							style="width: 360px;height: 124px;background: #F8F8F8;border-radius: 10px;box-sizing: border-box;padding: 0 12px;">
								<div style="width: 100px;height: 100px;">
									<img style="width: 100px;height: 100px;" src="../../assets/brand_fixtures/gudingtu.png" />
								</div>
								<div style="height: 100px;margin-left: 10px;">
									<div>整体推广</div>
									<div style="margin-top: 33px;" class="d-flex a-center">
										<div style="font-size: 12px;color: #888888;">分享他人阅览：</div>
										<el-input v-model="target_num" class="number" size="mini" style="width: 80px;margin-left: 6px;" type="number" placeholder="请输入"></el-input>
										<div style="font-size: 12px;color: #888888;margin-left: 15px;"> 次</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div style="font-size: 14px;margin-top: 30px;" class="d-flex a-center">
							产品/服务 <div @click="cpState=true" style="margin-left: 98px;color: #1E69FF;cursor: pointer;">+添加</div>
						</div>
						<div class="tgcpfw-box" style="display: flex;flex-wrap:wrap;justify-content: space-between;min-height: 124rpx;margin-top: 13px;">
							<div v-for="(item,index) in goodsList" :key="index" v-if="item.checked" class="d-flex a-center" style="width: 360px;height: 124px;background: #F8F8F8;
							border-radius: 10px;box-sizing: border-box;padding: 0 12px;margin-bottom: 25px;">
								<div style="width: 100px;height: 100px;">
									<img style="width: 100px;height: 100px;" :src="item.goods_thumb" />
								</div>
								<div style="height: 100px;margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;">
									<div>{{item.goods_name}}</div>
									<div class="d-flex a-center">
										<div style="font-size: 12px;color: #888888;">分享他人阅览：</div>
										<el-input v-model="item.target_num" class="number" size="mini" 
										style="width: 80px;margin-left: 6px;" type="number" placeholder="请输入"></el-input>
										<div style="font-size: 12px;color: #888888;margin-left: 15px;"> 次</div>
									</div>
									<div @click="item.checked=false" style="font-size: 12px;cursor: pointer;" class="d-flex a-center">
										<img style="width: 12px;height: 12px;" src="../../assets/brand_fixtures/shanchu.png" />
										<div style="margin-left: 3px;" >删除</div>
									</div>
								</div>
							</div>
						</div>
						<div style="font-size: 14px;margin-top: 30px;" class="d-flex a-center">
							动态 <div @click="ljState=true" style="margin-left: 133px;color: #1E69FF;cursor: pointer;">+添加</div>
						</div>
						<div class="tgcpfw-box" style="display: flex;flex-wrap:wrap;justify-content: space-between;min-height: 124rpx;margin-top: 13px;">
							<div v-for="(item,index) in busList" :key="index" v-if="item.checked" class="d-flex a-center" style="width: 360px;height: 124px;background: #F8F8F8;
							border-radius: 10px;box-sizing: border-box;padding: 0 12px;margin-bottom: 25px;">
								<div style="width: 100px;height: 100px;" class="d-flex a-center">
									<img v-if="item.doc_type==0" style="width: 100px;height: 68px;" :src="item.cover" />
									<video  v-for="(val,key) in item.act_desc" v-if="item.doc_type==1&&val.type==2"
									width="100" height="68" :src="val.content"/>
								</div>
								<div style="height: 100px;margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;">
									<div>{{item.title}}</div>
									<div class="d-flex a-center">
										<div style="font-size: 12px;color: #888888;">分享他人阅览：</div>
										<el-input v-model="item.target_num" class="number" size="mini" 
										style="width: 80px;margin-left: 6px;" type="number" placeholder="请输入"></el-input>
										<div style="font-size: 12px;color: #888888;margin-left: 15px;"> 次</div>
									</div>
									<div @click="item.checked=false" style="font-size: 12px;cursor: pointer;" class="d-flex a-center">
										<img style="width: 12px;height: 12px;" src="../../assets/brand_fixtures/shanchu.png" />
										<div style="margin-left: 3px;" >删除</div>
									</div>
								</div>
							</div>
						</div>
						<div style="font-size: 14px;margin-top: 30px;" class="d-flex a-center">
							活动 <div @click="hdState=true" style="margin-left: 133px;color: #1E69FF;cursor: pointer;">+添加</div>
						</div>
						<div class="tgcpfw-box" style="display: flex;flex-wrap:wrap;justify-content: space-between;min-height: 124rpx;margin-top: 13px;">
							<div v-for="(item,index) in activiList" v-if="item.checked" :key="index" class="d-flex a-center" style="width: 360px;height: 124px;background: #F8F8F8;
							border-radius: 10px;box-sizing: border-box;padding: 0 12px;margin-bottom: 25px;">
								<div style="width: 100px;height: 100px;" class="d-flex a-center">
									<img style="width: 100px;height: 54px;" :src="item.cover" />
								</div>
								<div style="height: 100px;margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;">
									<div >{{item.title}}</div>
									<div class="d-flex a-center">
										<div style="font-size: 12px;color: #888888;">分享他人阅览：</div>
										<el-input v-model="item.target_num" class="number" size="mini" 
										style="width: 80px;margin-left: 6px;" type="number" placeholder="请输入"></el-input>
										<div style="font-size: 12px;color: #888888;margin-left: 15px;"> 次</div>
									</div>
									<div @click="item.checked=false" style="font-size: 12px;cursor: pointer;" class="d-flex a-center">
										<img style="width: 12px;height: 12px;" src="../../assets/brand_fixtures/shanchu.png" />
										<div style="margin-left: 3px;" >删除</div>
									</div>
								</div>
							</div>
						</div>
					</template>
		  	  </div>
		  	  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
		  		  <div style="font-size: 12px;color: #888888;"></div>
		  		  <div class="d-flex a-center" style="margin-left: auto;">
		  			  <el-button @click="tgState=false" size="mini">取消</el-button>
		  			  <el-button  type="primary" @click="add_spread_info()" size="mini">保存</el-button>
		  		  </div>
		  	  </div>
		    </el-dialog>
			<el-dialog
			  :modal="true"
			  :visible.sync="tgDetail"
			  width="1170px"
			  top="5vh"
			  :show-close="true"
			  :close-on-press-escape="false"
			  :close-on-click-modal	="false">
				  <slot name="title">
				  </slot>
				  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
						<div style="padding-bottom: 7px;cursor: pointer;border-bottom: 2px solid #226CFF;color:#226CFF">
						推广详情
						</div>
				  </div>
				  <div class="tg-box" style="height: 630px;padding: 0px;box-sizing: border-box;overflow-y: scroll;">
					  <div style="font-size: 14px;font-weight: 700;margin-top: 30px;">
					  	推广人信息
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;color: #888888;margin-top: 12px;">
						  <div>{{spreadInfo.name}}</div>
						  <div style="margin-left: 14px;">{{spreadInfo.mobile}}</div>
						  <div style="margin-left: 14px;">{{spreadInfo.region}}(推广区域)</div>
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;color: #888888;margin-top: 12px;">
						  <div>创建于：{{spreadInfo.time}}</div>
					  </div>
					  <div style="font-size: 14px;font-weight: 700;margin-top: 30px;">
					  	总进度
					  </div>
					  <div class="d-flex a-center" style="margin-top: 11px;">
					  	<div class="d-flex a-center" style="width: 200px;height: 6px;background: #DBDBDB;border-radius: 3px;">
					  		<div style="height: 6px;background: #1E69FF;border-radius: 3px;" :style="'width:'+spreadInfo.total_progress+'%'">
					  		</div>
					  	</div>
					  	<div style="margin-left: 15px;font-size: 12px;color: #1E69FF;">{{spreadInfo.total_progress}}%</div>
					  </div>
					  
					  <template v-if="spreadInfo.spread_type == 0">
					  	<div  style="display: flex;margin-top: 30px;">
					  		<div class="d-flex a-center"
					  		style="width: 360px;height: 124px;background: #F8F8F8;border-radius: 10px;box-sizing: border-box;padding: 0 12px;">
					  			<div style="width: 100px;height: 100px;">
					  				<img style="width: 100px;height: 100px;" src="../../assets/brand_fixtures/gudingtu.png" />
					  			</div>
					  			<div style="height: 100px;margin-left: 10px;">
					  				<div>整体推广</div>
					  				<div class="d-flex" style="margin-top: 13px;">
										<div style="width: 72px;">
											<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
												{{spreadInfo.spread_business.target_num}}次
											</div>
											<div style="font-size: 12px;color: #888888;margin-top: 6px;">
												分享他人阅览
											</div>
										</div>
										<div style="width: 72px;margin-left: 37px;">
											<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
												{{spreadInfo.spread_business.actual_num}}次
											</div>
											<div style="font-size: 12px;color: #888888;margin-top: 6px;">
												已分享阅览
											</div>
										</div>
									</div>
									<div class="d-flex a-center" style="margin-top: 11px;">
										<div class="d-flex a-center" style="width: 170px;height: 6px;background: #DBDBDB;border-radius: 3px;">
											<div style="height: 6px;background: #1E69FF;border-radius: 3px;" :style="'width:'+spreadInfo.spread_business.item_progress+'%'">
											</div>
										</div>
										<div style="margin-left: 15px;font-size: 12px;color: #1E69FF;">{{spreadInfo.spread_business.item_progress}}%</div>
									</div>
					  			</div>
					  		</div>
					  	</div>
					  </template>
					  <template v-else>
					  	<div v-if="spreadInfo.spread_goods_list" style="font-size: 14px;margin-top: 30px;" class="d-flex a-center">
					  		产品/服务
					  	</div>
					  	<div class="tgcpfw-box" style="display: flex;flex-wrap:wrap;justify-content: space-between;min-height: 124rpx;margin-top: 13px;">
					  		<div v-for="(item,index) in spreadInfo.spread_goods_list" :key="index" class="d-flex a-center" style="width: 360px;height: 124px;background: #F8F8F8;
					  		border-radius: 10px;box-sizing: border-box;padding: 0 12px;margin-bottom: 25px;">
					  			<div style="width: 100px;height: 100px;">
					  				<img style="width: 100px;height: 100px;" :src="item.goods_img" />
					  			</div>
					  			<div style="height: 100px;margin-left: 10px;">
					  				<div class="thd" style="width: 200px;" :title="item.goods_name" >{{item.goods_name}}</div>
					  				<div class="d-flex" style="margin-top: 13px;">
					  					<div style="width: 72px;">
					  						<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
					  							{{item.target_num}}次
					  						</div>
					  						<div style="font-size: 12px;color: #888888;margin-top: 6px;">
					  							分享他人阅览
					  						</div>
					  					</div>
										<div style="width: 72px;margin-left: 37px;">
											<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
												{{item.actual_num}}次
											</div>
											<div style="font-size: 12px;color: #888888;margin-top: 6px;">
												已分享阅览
											</div>
										</div>
					  				</div>
					  				<div class="d-flex a-center" style="margin-top: 11px;">
					  					<div class="d-flex a-center" style="width: 170px;height: 6px;background: #DBDBDB;border-radius: 3px;">
					  						<div style="height: 6px;background: #1E69FF;border-radius: 3px;" :style="'width:'+item.item_progress+'%'">
					  						</div>
					  					</div>
					  					<div style="margin-left: 15px;font-size: 12px;color: #1E69FF;">{{item.item_progress}}%</div>
					  				</div>
					  			</div>
					  		</div>
					  	</div>
					  	<div v-if="spreadInfo.spread_dynamic_list" style="font-size: 14px;margin-top: 30px;" class="d-flex a-center">
					  		动态
					  	</div>
					  	<div class="tgcpfw-box" style="display: flex;flex-wrap:wrap;justify-content: space-between;min-height: 124rpx;margin-top: 13px;">
					  		<div v-for="(item,index) in spreadInfo.spread_dynamic_list" :key="index" class="d-flex a-center" style="width: 360px;height: 124px;background: #F8F8F8;
					  		border-radius: 10px;box-sizing: border-box;padding: 0 12px;margin-bottom: 25px;">
					  			<div style="width: 100px;height: 100px;" class="d-flex a-center">
					  				<img v-if="checkImgType(item.dynamic_cover)" style="width: 100px;height: 68px;" :src="item.dynamic_cover" />
					  				<video v-else width="100" height="68" :src="item.dynamic_cover"/>
					  			</div>
					  			<div style="height: 100px;margin-left: 10px;">
					  				<div class="thd" style="width: 200px;" :title="item.dynamic_title" >{{item.dynamic_title}}</div>
					  				<div class="d-flex" style="margin-top: 13px;">
					  					<div style="width: 72px;">
					  						<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
					  							{{item.target_num}}次
					  						</div>
					  						<div style="font-size: 12px;color: #888888;margin-top: 6px;">
					  							分享他人阅览
					  						</div>
					  					</div>
					  					<div style="width: 72px;margin-left: 37px;">
					  						<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
					  							{{item.actual_num}}次
					  						</div>
					  						<div style="font-size: 12px;color: #888888;margin-top: 6px;">
					  							已分享阅览
					  						</div>
					  					</div>
					  				</div>
					  				<div class="d-flex a-center" style="margin-top: 11px;">
					  					<div class="d-flex a-center" style="width: 170px;height: 6px;background: #DBDBDB;border-radius: 3px;">
					  						<div style="height: 6px;background: #1E69FF;border-radius: 3px;" :style="'width:'+item.item_progress+'%'">
					  						</div>
					  					</div>
					  					<div style="margin-left: 15px;font-size: 12px;color: #1E69FF;">{{item.item_progress}}%</div>
					  				</div>
					  			</div>
					  		</div>
					  	</div>
					  	<div v-if="spreadInfo.spread_act_list" style="font-size: 14px;margin-top: 30px;" class="d-flex a-center">
					  		活动 
					  	</div>
					  	<div class="tgcpfw-box" style="display: flex;flex-wrap:wrap;justify-content: space-between;min-height: 124rpx;margin-top: 13px;">
					  		<div v-for="(item,index) in spreadInfo.spread_act_list" :key="index" class="d-flex a-center" style="width: 360px;height: 124px;background: #F8F8F8;
					  		border-radius: 10px;box-sizing: border-box;padding: 0 12px;margin-bottom: 25px;">
					  			<div style="width: 100px;height: 100px;" class="d-flex a-center">
					  				<img style="width: 100px;height: 54px;" :src="item.act_cover" />
					  			</div>
					  			<div style="height: 100px;margin-left: 10px;">
					  				<div class="thd" style="width: 200px;" :title="item.act_title" >{{item.act_title}}</div>
					  				<div class="d-flex" style="margin-top: 13px;">
					  					<div style="width: 72px;">
					  						<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
					  							{{item.target_num}}次
					  						</div>
					  						<div style="font-size: 12px;color: #888888;margin-top: 6px;">
					  							分享他人阅览
					  						</div>
					  					</div>
					  					<div style="width: 72px;margin-left: 37px;">
					  						<div style="font-size: 13px;color: #000000;font-weight: 700;text-align: center;">
					  							{{item.actual_num}}次
					  						</div>
					  						<div style="font-size: 12px;color: #888888;margin-top: 6px;">
					  							已分享阅览
					  						</div>
					  					</div>
					  				</div>
					  				<div class="d-flex a-center" style="margin-top: 11px;">
					  					<div class="d-flex a-center" style="width: 170px;height: 6px;background: #DBDBDB;border-radius: 3px;">
					  						<div style="height: 6px;background: #1E69FF;border-radius: 3px;" :style="'width:'+item.item_progress+'%'">
					  						</div>
					  					</div>
					  					<div style="margin-left: 15px;font-size: 12px;color: #1E69FF;">{{item.item_progress}}%</div>
					  				</div>
					  			</div>
					  		</div>
					  	</div>
					  </template>
					  
				  </div>
				  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
					  <div style="font-size: 12px;color: #888888;"></div>
					  <div class="d-flex a-center" style="margin-left: auto;">
						  <el-button @click="tgDetail=false" size="mini">取消</el-button>
						  <el-button  type="primary" @click="tgDetail=false" size="mini">确定</el-button>
					  </div>
				  </div>
			  </el-dialog>
			<el-dialog
			  :modal="true"
			  :visible.sync="cpState"
			  width="1170px"
			  top="5vh"
			  :show-close="true"
			  :close-on-press-escape="false"
			  :close-on-click-modal	="false">
				  <slot name="title">
				  </slot>
				  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
						<div style="padding-bottom: 7px;cursor: pointer;margin-left: 15px;border-bottom: 2px solid #226CFF;color:#226CFF">
						添加产品
						</div>
				  </div>
				  <div style="height: 630px;padding: 0 24px;box-sizing: border-box;overflow-y: scroll;">
						<!-- <el-input placeholder="请输入内容" v-model="goodsKeyword" style="width: 280px;margin: 21px 0;" size="small">
						  <el-button slot="append" icon="el-icon-search"></el-button>
						</el-input> -->
						<div style="height: 25px;"></div>
						<div class="goods-box" style="display: flex;justify-content: space-between;flex-wrap: wrap;">
						  <div v-for="(item,index) in goodsList" :key="index" @click="setGoods(item)" style="cursor: pointer;margin-bottom: 20px;" class="d-flex a-center">
							  <img v-if="item.checked" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/xuanzhong.png" />
							  <img v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/moren.png" />
							  <img style="width: 60px;height: 60px;margin-left: 9px;" :src="item.goods_thumb" />
							  <div style="display: flex;height: 60px;justify-content: space-between;flex-direction: column;
							  color: #666666;font-size: 12px;margin-left: 11px;width: 210px;">
								  <div class="text-hide-2">{{item.goods_name}}</div>
								  <div>发布时间：{{item.add_time}}</div>
							  </div>
						  </div>
						</div>
				  </div>
				  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
					  <div style="font-size: 12px;color: #888888;">*选择产品</div>
					  <div class="d-flex a-center" style="margin-left: auto;">
						  <el-button @click="cpState=false" size="mini">取消</el-button>
						  <el-button @click="cpState=false" type="primary" size="mini">确定</el-button>
					  </div>
				  </div>
		</el-dialog>
		<el-dialog
		  :modal="true"
		  :visible.sync="ljState"
		  width="1170px"
		  top="5vh"
		  :show-close="true"
		  :close-on-press-escape="false"
		  :close-on-click-modal	="false">
			  <slot name="title">
			  </slot>
			  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
					<div style="padding-bottom: 7px;cursor: pointer;margin-left: 15px;border-bottom: 2px solid #226CFF;color:#226CFF">
					企业动态
					</div>
			  </div>
			  <div style="height: 630px;padding: 0 24px;box-sizing: border-box;overflow-y: scroll;">
				  <div v-if="busList.length">
					<!--  <el-input placeholder="请输入内容" v-model="keyword" style="width: 280px;margin: 21px 0;" size="small">
						  <el-button slot="append" icon="el-icon-search"></el-button>
					  </el-input> -->
					  <div style="height: 25px;"></div>
					  <div class="goods-box" style="display: flex;justify-content: space-between;flex-wrap: wrap;">
						  <div v-for="(item,index) in busList" :key="index" @click="item.checked=!item.checked" style="cursor: pointer;" class="d-flex a-center">
							  <img v-if="item.checked" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/xuanzhong.png" />
							  <img v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/moren.png" />
							  <img v-if="item.doc_type==0" style="width: 92px;height: 60px;margin-left: 9px;" :src="item.cover" />
							  <video style="margin-left: 9px;" v-for="(val,key) in item.act_desc" v-if="item.doc_type==1&&val.type==2"
							  width="92" height="60" :src="val.content"/>
							  <div style="display: flex;height: 60px;justify-content: space-between;flex-direction: column;
							  color: #666666;font-size: 12px;margin-left: 11px;width: 210px;">
								  <div class="text-hide-2">{{item.title}}</div>
								  <div class="d-flex a-center j-center" style="width: 40px;height: 16px;background: #FFFFFF;border: 1px solid #888888;border-radius: 2px;box-sizing: border-box;">
									  {{item.doc_type==0?'文章':'视频'}}
								  </div>
							  </div>
						  </div>
					  </div>
				  </div>
				  <div v-else class="d-flex j-center" style="margin-top: 20%;">
					  <div>
						  <div style="text-align: center;">
							  <img style="width: 124px;height: 76px;" src="../../assets/brand_fixtures/zanwurenhejil.png"/>
						  </div>
						  <div style="text-align: center;font-size: 12px;color: #888888;margin-top: 0px;">
							 暂无相关数据
						  </div>
						  <div class="d-flex j-center" style="margin-top: 15px;">
							  <el-button @click="$router.push('/ent_dynamic/index')" type="primary" size="small" style="width: 100px;" >去添加</el-button>
						  </div>
					  </div>
				  </div>
			  </div>
			  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				  <div style="font-size: 12px;color: #888888;">*帮助你的广告图跳转你想要的页面</div>
				  <div class="d-flex a-center" style="margin-left: auto;">
					  <el-button @click="ljState=false" size="mini">取消</el-button>
					  <el-button @click="ljState=false" type="primary" size="mini">确定</el-button>
				  </div>
			  </div>
		  </el-dialog>
		  <el-dialog
		  		  :modal="true"
		  		  :visible.sync="hdState"
		  		  width="1170px"
		  		  top="5vh"
		  		  :show-close="true"
		  		  :close-on-press-escape="false"
		  		  :close-on-click-modal	="false">
		  			  <slot name="title">
		  			  </slot>
		  			  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
		  					<div style="padding-bottom: 7px;cursor: pointer;margin-left: 15px;border-bottom: 2px solid #226CFF;color:#226CFF">
		  					已发布活动
		  					</div>
		  			  </div>
		  			  <div style="height: 630px;padding: 0 24px;box-sizing: border-box;overflow-y: scroll;">
		  				  <div v-if="activiList.length">
		  					  <!-- <el-input placeholder="请输入内容" v-model="goodsKeyword" style="width: 280px;margin: 21px 0;" size="small">
		  						  <el-button slot="append" icon="el-icon-search"></el-button>
		  					  </el-input> -->
							  <div style="height: 25px;"></div>
		  					  <div class="goods-box" style="display: flex;justify-content: space-between;flex-wrap: wrap;">
		  						  <div v-for="(item,index) in activiList" :key="index" @click="item.checked=!item.checked" style="cursor: pointer;" class="d-flex a-center">
		  							  <img v-if="item.checked" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/xuanzhong.png" />
		  							  <img v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/moren.png" />
		  							  <img style="width: 100px;height: 60px;margin-left: 9px;" :src="item.cover" />
		  							  <div style="display: flex;height: 60px;justify-content: space-between;flex-direction: column;
		  							  color: #666666;font-size: 12px;margin-left: 11px;width: 210px;">
		  								  <div class="text-hide-2">{{item.title}}</div>
		  <!-- 								  <div>发布时间：{{item.add_time}}</div> -->
		  							  </div>
		  						  </div>
		  					  </div>
		  				  </div>
		  				  <div v-else class="d-flex j-center" style="margin-top: 20%;">
		  					  <div>
		  						  <div style="text-align: center;">
		  							  <img style="width: 124px;height: 124px;" src="../../assets/brand_fixtures/zwhd.png"/>
		  						  </div>
		  						  <div class="d-flex j-center" style="margin-top: 15px;">
		  							  <el-button @click="gotoind()" type="primary" size="small" style="width: 100px;" >去添加</el-button>
		  						  </div>
		  					  </div>
		  				  </div>
		  				 
		  			  </div>
		  			  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
		  				  <div style="font-size: 12px;color: #888888;">*帮助你的广告图跳转你想要的页面</div>
		  				  <div class="d-flex a-center" style="margin-left: auto;">
		  					  <el-button @click="hdState=false" size="mini">取消</el-button>
		  					  <el-button @click="hdState=false" type="primary" size="mini">确定</el-button>
		  				  </div>
		  			  </div>
		  		  </el-dialog>
				  <el-dialog
				    :modal="true"
				    :visible.sync="qysp"
				    width="1170px"
				    top="5vh"
				    :show-close="true"
				    :close-on-press-escape="false"
				    :close-on-click-modal	="false">
				  	  <slot name="title">
				  	  </slot>
				  	  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
				  			<div style="padding-bottom: 7px;cursor: pointer;border-bottom: 2px solid #226CFF;color:#226CFF">
				  			{{qyspItem.shop_name}}
				  			</div>
				  	  </div>
				  	  <div style="height: 630px;box-sizing: border-box;overflow-y: scroll;">
				  			<div class="goods-box" style="display: flex;justify-content: space-between;flex-wrap: wrap;">
				  			  <div v-for="(item,index) in qyspGoodsList" :key="index" @click="item.checked=!item.checked" style="cursor: pointer;margin-top: 45px;" class="d-flex a-center">
				  				  <img v-if="item.checked" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/xuanzhong.png" />
				  				  <img v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/moren.png" />
				  				  <img style="width: 60px;height: 60px;margin-left: 9px;" :src="item.goods_img" />
				  				  <div style="display: flex;height: 60px;justify-content: space-between;flex-direction: column;
				  				  color: #666666;font-size: 12px;margin-left: 11px;width: 210px;">
				  					  <div class="text-hide-2">{{item.goods_name}}</div>
									  <div style="color: #DD3737;">￥{{item.shop_price}}</div>
				  				  </div>
				  			  </div>
				  			</div>
				  	  </div>
				  	  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				  		  <div style="font-size: 12px;color: #888888;">*选中商品且门店位展示状态会在企业首页显示，可跳转企业说品门店</div>
				  		  <div class="d-flex a-center" style="margin-left: auto;">
							  <div class="d-flex a-center">
									<img v-if="isAll" @click="setAll(false)" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/xuanzhong.png" />
									<img v-else @click="setAll(true)" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/brand_fixtures/moren.png" />
									<div style="font-size: 14px;margin-left: 5px;">全选</div>
							  </div>
				  			  <el-button @click="qysp=false" style="margin-left: 36px;" size="mini">取消</el-button>
				  			  <el-button  @click="ctrl_relation_bu_shop({},3)" type="primary" size="mini">设为展示</el-button>
				  		  </div>
				  	  </div>
				    </el-dialog>
					
		<el-dialog :modal="true" :visible.sync="setColor" width="800px" top="15vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="配置背字体/景颜色" center>
			<div style="padding: 0 30px;">
				<div style="font-size: 14px;font-weight: 600;margin-top: 30px;">配置背景颜色</div>
				<div style="color: #888888;font-size: 12px;margin-top: 13px;">请点击鼠标在选色版上选择你需要的颜色点击确定即可，不选择颜色默认淡灰底色。</div>
				<div class="d-flex a-center" style="margin-top: 7px;">
					<el-color-picker v-model="colour_code" show-alpha></el-color-picker>
					<div style="font-size: 12px;color: #888888;margin-left: 10px;">点击左方选色板选择背景色</div>
				</div>
				<div style="font-size: 14px;font-weight: 600;margin-top: 60px;">配置字体颜色</div>
				<div style="color: #888888;font-size: 12px;margin-top: 13px;">字体颜色适用于各大类标题部分</div>
				<div class="d-flex a-center" style="margin-top: 7px;">
					<div @click="colour_words = 0" class="d-flex a-center" style="cursor: pointer;">
						<div style="width: 28px;height: 28px;background: #000000;border-radius: 6px;border: 1px solid #000000;"></div>
						<div style="font-size: 14px;margin-left: 6px;color: #888888;">黑色</div>
						<img v-if="colour_words==0" src="../../assets/brand_fixtures/xuanzhong.png" style="width: 16px;height: 16px;margin-left: 6px;" />
						<img v-else src="../../assets/brand_fixtures/moren.png" style="width: 16px;height: 16px;margin-left: 6px;" />
					</div>
					<div @click="colour_words = 1"  class="d-flex a-center" style="margin-left: 50px;cursor: pointer;">
						<div style="width: 28px;height: 28px;background: #ffffff;border-radius: 6px;border: 1px solid #cccccc;"></div>
						<div style="font-size: 14px;margin-left: 6px;color: #888888;">白色</div>
						<img v-if="colour_words==1" src="../../assets/brand_fixtures/xuanzhong.png" style="width: 16px;height: 16px;margin-left: 6px;" />
						<img v-else src="../../assets/brand_fixtures/moren.png" style="width: 16px;height: 16px;margin-left: 6px;" />
					</div>
				</div>
			</div>
			
			<div style="border-top: 1px solid #BBBBBB;padding-top: 25px;margin-top: 80px;" class="d-flex a-center">
				<div style="font-size: 12px;color: #888888;"></div>
				<div class="d-flex a-center" style="margin-left: auto;">
					<el-button @click="setColor=false" size="mini">取消</el-button>
					<el-button @click="setColor=false" type="primary" size="mini">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :modal="true" :visible.sync="category" width="1200px" top="15vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="分类设定" center>
			<div style="padding-left: 370px;height: 500px;overflow-y: scroll;">
				<el-button @click="addOne()" type="primary" size="small">创建一级分类</el-button>
				<div style="margin-top: 20px;" v-for="(item,index) in category_data" :key="index">
					<div class="d-flex a-center">
						<el-input v-model="item.cat_name" style="width: 240px;" size="mini" placeholder="请输入内容">
							<template slot="append">
								<div @click="item.show = !item.show" style="cursor: pointer;" class="d-flex a-center">
									<img v-if="item.show" style="width: 12px;height: 12px;" src="../../assets/itemStore/xiala.png" />
									<img v-else style="width: 12px;height: 12px;" src="../../assets/brand_fixtures/xialayou(1).png" />
								</div>
							</template>
						</el-input>
						<el-button @click="addTwo(item)" style="margin-left: 20px;" type="primary" size="mini">+添加二级分类</el-button>
						<img @click="delOne(index,item)" style="width: 14px;height: 14px;margin-left: 20px;cursor: pointer;" src="../../assets/brand_fixtures/shanchu.png" />
					</div>
					<div v-if="item.show" style="padding-left: 14px;" v-for="(val,key) in item.child" :key="key">
						<div style="height: 16px;border-left: 1px dashed #bbbbbb;"></div>
						<div class="d-flex a-center">
							<div style="width: 14px;">
								<div style="border-left: 1px dashed #bbbbbb;;height: 13px;"></div>
								<div style="border-bottom: 1px dashed #bbbbbb;;height: 1px;width: 13px;"></div>
								<div v-if="(item.child.length-1) != key" style="border-left: 1px dashed #bbbbbb;;height: 13px;"></div>
								<div v-else style="border-left: 1px dashed #ffffff;;height: 13px;"></div>
							</div>
							<el-input v-model="val.cat_name" style="width: 210px;" size="mini" placeholder="请输入内容"/>
							<img @click="delTwo(item,key)" style="width: 14px;height: 14px;margin-left: 20px;cursor: pointer;" src="../../assets/brand_fixtures/shanchu.png" />
						</div>
					</div>
					
				</div>
			</div>
			<div style="border-top: 1px solid #BBBBBB;padding-top: 25px;margin-top: 80px;" class="d-flex a-center">
				<div style="font-size: 12px;color: #888888;">
					*设定好分类列表可在“甄选列表”添加产品服务至分类列表
				</div>
				<div class="d-flex a-center" style="margin-left: auto;">
					<el-button @click="category=false" size="mini">取消</el-button>
					<el-button @click="save_enterprise_selection_category" type="primary" size="mini">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :modal="true" :visible.sync="goodsStatus" width="1200px" top="15vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="分类产品设定" center>
			<div>当前选中分类：{{curZx.cat_name}}</div>
			<div style="height: 500px;overflow-y: scroll;padding: 0 100px;box-sizing: border-box;">
				<div class="goodsStatus" style="display: flex;flex-wrap: wrap;justify-content: space-between;">
					<div v-for="(item,index) in zxGoods" :key="index" style="margin-top: 20px;cursor: pointer;"
					@click="item.checked = !item.checked" class="d-flex a-center" >
						<img v-if="item.checked" style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/xuanzhong.png" />
						<img v-else style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/moren.png" />
						<img style="width: 60px;height: 60px;margin-left: 10px;" :src="item.goods_img" />
						<div style="height: 58px;width: 160px;margin-left: 10px;" class="d-flex jc-sb flex-column">
							<div class="text-hide-2" style="font-size: 12px;">{{item.goods_name}}</div>
							<div style="color: #888888;font-size: 12px;">{{item.business_name}}</div>
						</div>
					</div>
				</div>
			</div>
			<div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				<div style="font-size: 12px;color: #888888;">
					*设定的产品/服务将在指定的分类中展示
				</div>
				<div class="d-flex a-center" style="margin-left: auto;">
					<el-button @click="goodsStatus=false" size="mini">取消</el-button>
					<el-button @click="save_selection_category_goods()" type="primary" size="mini">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :modal="true" :visible.sync="zxtjSqState" width="1200px" top="15vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="申请入驻" center>
			<div style="margin-bottom: 10px;" class="d-flex a-center">
				选择“甄选推荐”入驻企业/商协会
				<el-input placeholder="请输入搜索关键字" v-model="allKeyword" size="small" style="width: 260px;margin-left: auto;">
				    <el-button @click="createZxtjsq()" slot="append" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<div style="height: 500px;overflow-y: scroll;box-sizing: border-box;">
				<div class="goodsStatus" style="display: flex;flex-wrap: wrap;justify-content: space-between;">
					<div style="width: 320px;height: 84px;background: #F8F8F8;border-radius: 4px;margin-right: 16px;padding: 0 12px;margin-top: 16px;"
					v-for="(item,index) in all_bu_ass_list" :key="index" class="d-flex a-center">
						<img style="width: 60px;height: 60px;" :src="item.business_logo" />
						<div style="margin-left: 12px;display: flex;flex-direction: column;justify-content: space-between;
						height: 60px;">
							<div style="font-size: 12px;">{{item.business_name}}</div>
							<div style="font-size: 12px;color: #888888;">{{item.business_tel||'---'}}</div>
							<div @click="setCurLuzl(item)" style="font-size: 12px;color: #333333;width: 72px;height: 20px;background: #FFFFFF;cursor: pointer;
							border: 1px solid #888888;border-radius: 2px;box-sizing: border-box;" class="d-flex a-center j-center">
								产品入驻
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog :modal="true" :visible.sync="zx_lrzl_state" width="1200px" top="15vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="录入资料" center>
			<div style="font-size: 12px;" class="d-flex a-center">
				申请企业：<el-input size="mini" v-model="userInfo.company_name" disabled style="width: 221px;" ></el-input>
			</div>
			<div style="font-size: 12px;margin-top: 20px;" class="d-flex a-center">
				联系电话：<el-input size="mini" v-model="userInfo.kf_tel" disabled style="width: 221px;" ></el-input>
			</div>
			<div style="font-size: 12px;margin-top: 20px;" class="d-flex a-center">
				申请入驻产品/服务：<el-button @click="sel_product" size="mini" type="primary" style="margin-left: 110px;" >添加</el-button>
			</div>
			<div style="height: 366px;overflow-y: scroll;box-sizing: border-box;">
				<div style="display: flex;flex-wrap: wrap;">
					<div v-for="(item,index) in selGoods" :key="index" v-if="item.checked" style="margin-right: 60px;margin-top: 20px;" class="d-flex a-center" >
						<img style="width: 60px;height: 60px;" :src="item.goods_thumb" />
						<div style="height: 60px;width: 160px;margin-left: 10px;" class="d-flex jc-sb flex-column">
							<div class="text-hide-2" style="font-size: 12px;">{{item.goods_name}}</div>
							<img @click="item.checked=false" style="width: 14px;height: 14px;cursor: pointer;" src="../../assets/brand_fixtures/shanchu_wz.png" />
						</div>
					</div>
				</div>
			</div>
			<div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				<div style="font-size: 12px;color: #888888;">
					
				</div>
				<div class="d-flex a-center" style="margin-left: auto;">
					<el-button @click="zx_lrzl_state=false" size="mini">取消</el-button>
					<el-button @click="submit_selection_apply" type="primary" size="mini">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :modal="true" :visible.sync="luzl_sel_product" width="1200px" top="15vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="选择分类产品" center>
			<div style="height: 500px;overflow-y: scroll;padding: 0 100px;box-sizing: border-box;">
				<div class="goodsStatus" style="display: flex;flex-wrap: wrap;justify-content: space-between;">
					<div v-for="(item,index) in selGoods" :key="index" style="margin-top: 20px;cursor: pointer;"
					@click="item.checked = !item.checked" class="d-flex a-center" >
						<img v-if="item.checked" style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/xuanzhong.png" />
						<img v-else style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/moren.png" />
						<img style="width: 60px;height: 60px;margin-left: 10px;" :src="item.goods_thumb" />
						<div style="height: 58px;width: 160px;margin-left: 10px;" class="d-flex jc-sb flex-column">
							<div class="text-hide-2" style="font-size: 12px;">{{item.goods_name}}</div>
							<div style="color: #888888;font-size: 12px;">¥{{item.shop_price}}</div>
						</div>
					</div>
				</div>
			</div>
			<div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				<div style="font-size: 12px;color: #888888;">
				</div>
				<div class="d-flex a-center" style="margin-left: auto;">
					<el-button @click="luzl_sel_product=false" size="mini">取消</el-button>
					<el-button @click="luzl_sel_product=false" type="primary" size="mini">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :modal="true" :visible.sync="myDetail" width="1200px" top="15vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="查看详情" center>
			<div style="min-height: 500px;">
				<div class="d-flex a-center" style="font-size: 12px;">
					申请企业：{{curName}}
				</div>
				<div class="d-flex a-center" style="font-size: 12px;margin-top: 11px;">
					联系方式：{{curMobile}}
				</div>
				<div class="d-flex a-center" style="font-size: 12px;margin-top: 11px;">
					申请时间：{{$getDate(myDetailInfo.add_time)}}
				</div>
				<div class="d-flex a-center" style="font-size: 12px;margin-top: 11px;">
					审核状态：
					<div v-if="myDetailInfo.status==0">未审核</div>
					<div v-else-if="myDetailInfo.status==1">审核未通过</div>
					<div v-else-if="myDetailInfo.status==2">通过审核</div>
				</div>
				<div class="d-flex a-center" style="font-size: 12px;margin-top: 11px;">
					提交商品：
				</div>
				<div style="font-size: 12px;">
					<div style="display: flex;flex-wrap: wrap;">
						<div v-for="(item,index) in myDetailInfo.goods_list" :key="index" 
						style="margin-right: 60px;margin-top: 11px;" class="d-flex a-center" >
							<img style="width: 60px;height: 60px;" :src="item.goods_img" />
							<div style="height: 60px;width: 160px;margin-left: 10px;" class="d-flex jc-sb flex-column">
								<div class="text-hide-2" style="font-size: 12px;">{{item.goods_name}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="zxcpState == 1" style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				<div style="font-size: 12px;color: #888888;">
				</div>
				<div class="d-flex a-center" style="margin-left: auto;">
					<el-button @click="refuseState=true" size="mini">拒绝通过</el-button>
					<el-button @click="ctrl_selection_apply(0)" type="primary" size="mini">审核通过</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :modal="true" :visible.sync="refuseState" width="600px" top="30vh" :show-close="true"
			:close-on-press-escape="false" :close-on-click-modal="false" title="拒绝通过" center>
			<el-input
			  type="textarea"
			  :rows="6"
			  placeholder="请输入内容"
			  v-model="refuseContent">
			</el-input>
			<div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				<div style="font-size: 12px;color: #888888;">
				</div>
				<div class="d-flex a-center" style="margin-left: auto;">
					<el-button @click="refuseState=false" size="mini">取消</el-button>
					<el-button @click="ctrl_selection_apply(1)" type="primary" size="mini">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
		  :modal="true"
		  :visible.sync="addTgy"
		  width="1170px"
		  top="5vh"
		  :show-close="true"
		  :close-on-press-escape="false"
		  :close-on-click-modal	="false">
			  <slot name="title">
			  </slot>
			  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
					<div style="padding-bottom: 7px;cursor: pointer;border-bottom: 2px solid #226CFF;color:#226CFF">
					添加推广员
					</div>
			  </div>
			  <div class="d-flex j-center">
				  <div>
					  <div style="margin-top: 160px;font-size: 14px;">添加推广员信息</div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 24px;">
						  <div style="width: 100px;">推广地区</div>
						  <el-input v-model="region" size="mini" style="width: 200px;"></el-input>
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 24px;">
						  <div style="width: 100px;">推广人姓名</div>
						  <el-input v-model="name" size="mini" style="width: 200px;"></el-input>
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 24px;">
						  <div style="width: 100px;">推广人电话</div>
						  <el-input v-model="mobile" size="mini" style="width: 200px;"></el-input>
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 24px;margin-bottom: 200px;">
						  <div style="width: 100px;">微信绑定号码</div>
						  <el-input v-model="micro_mobile" size="mini" style="width: 200px;"></el-input>
					  </div>
				  </div>
			  </div>
			  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				  <div style="font-size: 12px;color: #888888;">
					  *添加推广员可对推广员设定推广任务
				  </div>
				  <div class="d-flex a-center" style="margin-left: auto;">
					  <el-button @click="addTgy=false" size="mini">取消</el-button>
					  <el-button  type="primary" @click="add_spread_member" size="mini">确定</el-button>
				  </div>
			  </div>
		  </el-dialog>
		  <el-dialog
		    :modal="true"
		    :visible.sync="tgy_detail_state"
		    width="1170px"
		    top="13vh"
		    :show-close="true"
		    :close-on-press-escape="false"
		    :close-on-click-modal	="false">
		  	  <slot name="title">
		  	  </slot>
		  	  <div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
		  			<div style="padding-bottom: 7px;cursor: pointer;border-bottom: 2px solid #226CFF;color:#226CFF">
		  			推广员详情
		  			</div>
		  	  </div>
				<div class="d-flex j-center">
					<div>
					  <div style="margin-top: 50px;font-size: 14px;">添加推广员信息</div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 12px;">
						  <div style="width: 100px;">推广地区</div>
						  <el-input v-model="tgy_detail_info.region" size="mini" style="width: 200px;"></el-input>
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 12px;">
						  <div style="width: 100px;">推广人姓名</div>
						  <el-input v-model="tgy_detail_info.name" size="mini" style="width: 200px;"></el-input>
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 12px;">
						  <div style="width: 100px;">推广人电话</div>
						  <el-input v-model="tgy_detail_info.mobile" size="mini" style="width: 200px;"></el-input>
					  </div>
					  <div class="d-flex a-center" style="font-size: 12px;margin-top: 12px;margin-bottom: 10px;">
						  <div style="width: 100px;">微信绑定号码</div>
						  <el-input v-model="tgy_detail_info.micro_mobile" size="mini" style="width: 200px;"></el-input>
					  </div>
					</div>
				</div>
				<div v-if="tgy_detail_info.spread_info" class="d-flex j-center" style="margin-bottom: 50px;">
					<div>
					  <div style="margin-top: 50px;font-size: 14px;">进行中的任务</div>
					  <div 
					  style="width: 320px;height: 94px;background: #F8F8F8;border-radius: 4px;margin-top: 18px;box-sizing: border-box;padding: 12px;">
						<div class="d-flex a-center" style="font-size: 12px;">
							<div style="color: #888888;">{{tgy_detail_info.spread_info.add_spread_time}}</div>
							<div @click="openTgDetail(tgy_detail_info.spread_info)" style="margin-left: auto;cursor: pointer;" class="d-flex a-center">
								<div>详情</div>
								<img style="margin-left: 6px;width: 12px;height: 12px;" src="../../assets/Home/jiantou.png" />
							</div>
						</div>
						<div class="d-flex a-center j-sb" style="font-size: 12px;margin-top: 10px;">
							<div>{{tgy_detail_info.spread_info.name}}</div>
							<div>{{tgy_detail_info.spread_info.mobile}}</div>
							<div>{{tgy_detail_info.spread_info.region}}(推广区域)</div>
						</div>
						<div class="d-flex a-center" style="margin-top: 13px;">
							<div class="d-flex a-center" style="width: 200px;height: 6px;background: #DBDBDB;border-radius: 3px;">
								<div style="height: 6px;background: #1E69FF;border-radius: 3px;" :style="'width:'+tgy_detail_info.spread_info.total_progress+'%'">
								</div>
							</div>
							<div style="margin-left: 15px;font-size: 12px;color: #1E69FF;">{{tgy_detail_info.spread_info.total_progress}}%</div>
						</div>
					  </div>
					</div>			  
				</div>
		  	  <div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
		  		  <div style="font-size: 12px;color: #888888;">
		  			  *添加推广员可对推广员设定推广任务
		  		  </div>
		  		  <div class="d-flex a-center" style="margin-left: auto;">
		  			  <el-button @click="tgy_detail_state=false" size="mini">取消</el-button>
		  			  <el-button  @click="tgy_detail_state=false" type="primary" size="mini">确定</el-button>
		  		  </div>
		  	  </div>
		    </el-dialog>
			<el-dialog
			  :modal="true"
			  :visible.sync="sel_tgy_state"
			  width="1170px"
			  top="13vh"
			  :show-close="true"
			  :close-on-press-escape="false"
			  :close-on-click-modal	="false">
				<slot name="title">
				</slot>
				<div class="d-flex" style="border-bottom: 1px solid #bbbbbb;">
					<div style="padding-bottom: 7px;cursor: pointer;border-bottom: 2px solid #226CFF;color:#226CFF">
					选择人员
					</div>
				</div>
				<div style="height: 500px;overflow-y: scroll;box-sizing: border-box;">
					<div style="display: flex;flex-wrap: wrap;">
						<div v-for="(item,index) in sel_tgy_list" :key="index" style="width: 20%;">
							<div @click="item.checked=!item.checked" style="height: 32px;margin-top: 22px;cursor: pointer;" class="d-flex a-center">
								<div style="margin-right: 12px;" class="d-flex a-center">
									<img v-if="item.checked" style="width: 14px;height: 14px;cursor: pointer;" src="../../assets/brand_fixtures/xuanzhong.png" />
									<img v-else style="width: 14px;height: 14px;cursor: pointer;" src="../../assets/brand_fixtures/moren_tg.png" />
								</div>
								<div style="font-size: 14px;">
									{{item.name}}({{item.mobile}})
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style="border-top: 1px solid #BBBBBB;padding-top: 25px;" class="d-flex a-center">
				  <div style="font-size: 12px;color: #888888;">
					  *选择要添加的推广员
				  </div>
				  <div class="d-flex a-center" style="margin-left: auto;">
					  <!-- <el-button @click="sel_tgy_state=false" size="mini">取消</el-button> -->
					  <el-button @click="sel_tgy_state=false" type="primary"  size="mini">确定</el-button>
				  </div>
				</div>
			</el-dialog>
	</div>

</template>

<script>
	import VueUeditorWrap from 'vue-ueditor-wrap'
	import Draggable from 'vuedraggable'
	// import { imageUpload } from '@/api/commodity'
	import EditForm from '@/components/Edit/index'
	import Product from '@/components/View/Product'
	import Images from '@/components/View/Images'
	import Banner from '@/components/View/Banner'
	import Tabbar from '@/components/View/Tabbar'
	import Introduce from '@/components/View/Introduce'
	import Dynamic from '@/components/View/Dynamic'
	import Tuiguang from '@/components/View/Tuiguang'
	import Activity from '@/components/View/Activity'
	import Team from '@/components/View/Team'
	import Zizi from '@/components/View/Zizi'
	import Subsidiary from '@/components/View/Subsidiary'
	import Qiyequan from '@/components/View/Qiyequan'
	import Case from '@/components/View/Case'
	import Cpfl from '@/components/View/Cpfl'
	import Scene from '@/components/View/Scene'
	import AllProject from '@/components/View/AllProject'
	import Entsp from '@/components/View/Entsp'
	import Zxtj from '@/components/View/Zxtj'
	import { createLogger } from 'vuex'
	export default {
		components: {
			VueUeditorWrap,
			EditForm,
			Draggable,
			Product,
			Images,
			Tabbar,
			Banner,
			Introduce,
			Dynamic,
			Tuiguang,
			Activity,
			Team,
			Zizi,
			Subsidiary,
			Qiyequan,
			Case,
			Scene,
			AllProject,
			Entsp,
			Zxtj
		},
		data() {
			return {
				myConfig: {
				  // 编辑器不自动被内容撑高
				  autoHeightEnabled: false,
				  // 初始容器高度
				  initialFrameHeight: 530,
				  // 初始容器宽度
				  initialFrameWidth: 700,
				  // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
				  // serverUrl: 'https://ueditor.szcloudplus.com/cos',
				  // serverUrl: 'https://www.spmall.com/ueditor/controller.php',
				  // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
				  UEDITOR_HOME_URL: '/UEditor/'
				},
				token: localStorage.getItem('token'),
				user_id: localStorage.getItem('user_id'),
				alState:false,
				keyword:'',
				cgalList:[],
				wzContents:'',
				businessInfo:'',
				tableData:[],
				tabIndex: 0,
				ycIndex: 0,
				alIndex: 0,
				tdIndex: 0,
				alStatus: 0,
				tdStatus: 0,
				alList: [],
				tdList: [],
				case_id: '',
				team_id: '',
				dyIndex: '',
				cover:'',
				dyList:[],
				txtShow:false,
				txt:'',
				wzTitle:'',
				typeList: {
					// tabbar: {
					// 	name: '菜单管理',
					// 	com: Tabbar,
					// 	isopen: false,
					// 	img: require('../../assets/brand_fixtures/caidanmokaui.png')
					// },
					// banner: {
					// 	name: '轮播广告',
					// 	com: Banner,
					// 	isopen: false,
					// 	img: require('../../assets/brand_fixtures/lbgg.png')
					// },
					product: {
						name: '产品/服务类',
						com: Product,
						isopen: false,
						img: require('../../assets/brand_fixtures/chanpintu.png')
					},
					introduce: {
						name: '企业介绍',
						com: Introduce,
						isopen: false,
						img: require('../../assets/brand_fixtures/jies.png')
					},
					// entsp:{
					// 	name: '联系我们',
					// 	com: Entsp,
					// 	isopen: false,
					// 	img: require('../../assets/brand_fixtures/cpfenlei.png')
					// }
				},
				view: [],
				title: '',
				type: '',
				index: null, // 当前组件的索引
				isPush: false, // 是否已添加组件

				props: {}, // 传值
				isRight: false,

				className: {
					1: 'one',
					2: 'two',
					3: 'three'
				},
				background: [{
					color: '#f5f5f5'
				}],
				hdStatus:1,
				hdIndex:0,
				hdList:[],
				start_time:'',
				end_time:'',
				activity_id:'',
				zzList:[],
				companyList:[],
				companyData:[],
				company_name:'',
				spread:'',
				decor_user_module_list:[],
				join_users:[],
				tgState:false,
				spread_type:0,
				goodsList:[],
				cpState:false,
				goodsKeyword:'',
				busList:[],
				ljState:false,
				hdState:false,
				activiList:[],
				target_num:'',
				spread_id:'',
				name:'',
				mobile:'',
				region:'',
				micro_mobile:'',
				add_type:1,
				spread_list:[],
				sq_spread_list:[],
				tgDetail:false,
				spreadInfo:{},
				businessKeyword:'',
				shopKeyword:'',
				shopList:[],
				bd_shopList:[],
				qysp:false,
				qyspItem:'',
				qyspGoodsList:[],
				caseList:[],
				caseOptions:{},
				cpfwfl:[],
				productOptions:{},
				hjcjOptions:{
					user_module_name:'',
					content:'',
					source:0
				},
				allOptions:{},
				allList:[],
				shopNmae:'',
				bu_shop_list:[],
				circleOptions:{
					user_module_name:''
				},
				groupTotal:'',
				groupKeyword:'',
				currentPage:1,
				pageSize:10,
				total_records:0,
				setColor:false,
				colour_code:'#f8f8f8',
				colour_words: 0,
				category:false,
				category_data:[
					{
						cat_id:0,
						cat_name:'',
						show:true,
						child:[]
					}
				],
				categoryData:[],
				zxGoods:[],
				goodsStatus:false,
				curZx:'',
				zxcpState:0,
				zxcpPage:1,
				zxcpSize:10,
				zxcp_records:0,
				zxkeyword:'',
				zxtjSqState:false,
				all_bu_ass_list:[],
				allKeyword:'',
				zx_lrzl_state:false,
				userInfo:{},
				luzl_sel_product:false,
				selGoods:[],
				r_ru_id:'',
				apply_list:[],
				options: [{
				  value: '0',
				  label: '状态(未审核)'
				}, {
				  value: '1',
				  label: '状态(审核不通过)'
				}, {
				  value: '2',
				  label: '状态(审核通过)'
				}],
				value: '0',
				myDetail: false,
				myDetailInfo:{},
				curName:'',
				curMobile:'',
				refuseState:false,
				refuseContent:'',
				productList:[],
				tgTopState:1,
				editState:false,
				addTgy:false,
				tgyKeyword:'',
				tgy_list:[],
				sel_tgy_list:[],
				tgy_detail_state:false,
				tgy_detail_info:'',
				applyList:[],
				sel_applyList:[],
				applyTotal:0,
				applyPage:1,
				applySize:10,
				sel_tgy_state:false,
				
				qrcode_list:[],
				qrcode_img:'',
				qrcode_name:'',
				qrcode_id:'',
				gpe_paas_type:1
			}
		},
		mounted() {
			this.get_company_info()
			//首页菜单
			this.co_gpe_index_module_get()
			//中间区域菜单
			this.co_gpe_decor_module_list()
			this.$on('passtype',(res)=>{
				console.log(res);
			})
		},
		created() {
			this.$on('passtype',(res)=>{
				console.log(res);
			})
		},
		computed: {
			info() {
				return this.background[0]
			},
			isAll() {
				let status = true
				this.qyspGoodsList.forEach((item)=>{
					if(!item.checked){
						status = false
					}
				})
				return status
			},
			tgycheck(){
				let status = true
				this.tgy_list.forEach((item)=>{
					if(!item.checked){
						status = false
					}
				})
				return status
			}
		},
		methods: {
			admin_get_bu_contact_qr_code_list(){
				let params = {
					act:'admin_get_bu_contact_qr_code_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_bu_contact_qr_code_list(params).then((res)=>{
					if(res.code == 0){
						this.qrcode_list = res.data
					}
				})
			},
			qrcode_del(item,index){
				let params = {
					act:'admin_del_bu_contact_qr_code',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.admin_del_bu_contact_qr_code(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.qrcode_list.splice(index,1)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			fileSuccessQrcode(res){
				this.qrcode_img = this.$apiurl + res.data
			},
			editQrcode(item,index){
				if(item.qr_type==1){
					this.$message({
						showClose: false,
						message: '微网站二维码不可编辑!',
						type: 'warning',
						offset: 350,
						duration: 1500
					})
					return
				}else{
					this.qrcode_img = item.qr_code_url
					this.qrcode_id = item.id
					this.qrcode_name = item.qr_code_name
				}
			},
			saveQrcode(){
				if(this.qrcode_img==''){
					this.$message({
						showClose: false,
						message: '请上传二维码图片!',
						type: 'warning',
						offset: 350,
						duration: 1500
					})
					return
				}
				if(this.qrcode_name==''){
					this.$message({
						showClose: false,
						message: '请填写二维码名称',
						type: 'warning',
						offset: 350,
						duration: 1500
					})
					return
				}
				let params = {
					act:'admin_save_bu_contact_qr_code',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:this.qrcode_id,
					qr_code_url:this.qrcode_img,
					qr_code_name:this.qrcode_name
				}
				this.$api.admin_save_bu_contact_qr_code(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '保存成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.admin_get_bu_contact_qr_code_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			clearQrcode(){
				this.qrcode_img = ''
				this.qrcode_id = ''
				this.qrcode_name = ''
			},
			agree_spread_member(item){
				let params = {
					act:'ctrl_spread_member',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ctrl: 0,
					s_m_ids: item.s_m_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.spread_member_apply_list()
						this.spread_member_list()
					}
				})
			},
			del_spread_member(item){
				let params = {
					act:'ctrl_spread_member',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ctrl: 1,
					s_m_ids: item.s_m_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.spread_member_apply_list()
						this.spread_member_list()
					}
				})
			},
			allctrl_spread_member(ctrl){
				let arr = []
				this.sel_applyList.forEach((item)=>{
					arr.push(item.s_m_id)
				})
				if(arr.length){
					let params = {
						act:'ctrl_spread_member',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						ctrl: ctrl,
						s_m_ids: arr.join(',')
					}
					this.$api.publicity_manage_api(params).then((res)=>{
						if(res.code == 0){
							this.spread_member_apply_list()
							this.spread_member_list()
						}
					})
				}
			},
			handleSelectionChange(val) {
				this.sel_applyList = val
				console.log(val);
			},
			applySizeChange(size) {
				this.applySize = size;
				this.spread_member_apply_list()
			},
			applyPageChange(currentPage) {
				this.applyPage = currentPage;
				this.spread_member_apply_list()
			},
			spread_member_apply_list(){
				this.tgTopState = 3
				let params = {
					act:'spread_member_apply_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page: 1,
					size: 10
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.applyList = []
					this.applyTotal = 0
					if(res.code == 0){
						this.applyList = res.data
						this.applyTotal = res.total_records
					}
				})
			},
			ctrl_spread_member(){
				let arr = []
				this.tgy_list.forEach((item)=>{
					if(item.checked){
						arr.push(item.s_m_id)
					}
				})
				if(arr.length){
					let params = {
						act:'ctrl_spread_member',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						s_m_ids: arr.join(','),
						ctrl: 1
					}
					this.$api.publicity_manage_api(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								showClose: false,
								message: '删除成功',
								type: 'success',
								offset: 350,
								duration: 1500
							})
							this.spread_member_list()
						}else{
							this.$message({
								showClose: false,
								message: res.msg,
								type: 'error',
								offset: 350,
								duration: 1500
							})
						}
					})
				}
			},
			spread_member_info(item){
				let params = {
					act:'spread_member_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					s_m_id: item.s_m_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.tgy_detail_state = true
					this.tgy_detail_info = res.data
				})
			},
			alltgy(status){
				this.tgy_list.forEach((item)=>{
					item.checked = !status
				})
			},
			add_spread_member(){
				let params = {
					act:'add_spread_member',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					name: this.name,
					micro_mobile: this.micro_mobile,
					mobile: this.mobile,
					region: this.region
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.addTgy = false
						this.spread_member_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			spread_member_list(){
				let params = {
					act:'spread_member_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					keyword: this.tgyKeyword
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.tgy_list = []
					this.sel_tgy_list = []
					if(res.code == 0){
						res.data.forEach((item)=>{
							this.tgy_list.push({...item,checked:false})
							this.sel_tgy_list.push({...item,checked:false})
						})
					}
				})
			},
			del_selection_goods_list(item){
				let params = {
					act:'del_selection_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					e_sg_id: item.e_sg_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.get_selection_goods_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			ctrl_selection_apply(state){
				let params = {
					act:'ctrl_selection_apply',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					content: this.refuseContent,
					ctrl: state,
					apply_id: this.myDetailInfo.apply_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.refuseState = false
						this.myDetail = false
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			openMyDetail(){
				this.myDetail = true
			},
			get_selection_apply_info(item){
				let params = {
					act:'get_selection_apply_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					apply_id: item.apply_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.curName = item.s_ru_name
					this.curMobile = item.s_ru_mobile
					this.myDetailInfo = res.data
					this.openMyDetail()
				})
			},
			submit_selection_apply(){
				let ids = []
				this.selGoods.forEach((item)=>{
					if(item.checked){
						ids.push(item.id)
					}
				})
				if(ids.length == 0){
					this.$message({
						showClose: false,
						message: '请选择产品',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				let params = {
					act:'submit_selection_apply',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					s_ru_name: this.userInfo.company_name,
					s_ru_mobile: this.userInfo.kf_tel,
					r_ru_id: this.r_ru_id,
					apply_goods_ids: ids.join(',')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '提交成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.zx_lrzl_state = false
						this.zxtjSqState = false
						this.get_selection_apply_list(1,2)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			sel_product(){
				let params = {
					act:'enterprise_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					status: 1
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.selGoods = []
					res.data.forEach((item)=>{
						this.selGoods.push({checked:false,...item})
					})
					this.luzl_sel_product = true
				})
			},
			get_company_info(){
				let params = {
					act:'get_company_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.userInfo = res.data
					}
				})
			},
			setCurLuzl(item){
				this.zx_lrzl_state = true
				this.r_ru_id = item.business_id
			},
			createZxtjsq(){
				this.zxtjSqState = true
				let params = {
					act:'get_all_bu_ass_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page: 1,
					size: 99,
					keyword: this.allKeyword
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.all_bu_ass_list = res.data
					}
				})
			},
			get_selection_apply_list(state,type){
				// console.log(state);
				this.zxcpState = type
				let params = {
					act:'get_selection_apply_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page: 1,
					size: 99,
					keyword: '',
					get_data: state,
					status: this.value
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.apply_list = []
					if(res.code == 0){
						this.apply_list = res.data
					}
				})
			},
			zxcpSizeChange(size) {
				this.zxcpSzie = size;
				this.get_selection_goods_list()
			},
			zxcpPageChange(currentPage) {
				this.zxcpPage = currentPage;
				this.get_selection_goods_list()
			},
			get_selection_goods_list(){
				this.zxcpState = 0
				let params = {
					act:'get_selection_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					page: this.zxcpPage,
					size: this.zxcpSzie,
					keyword: this.zxkeyword
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.productList = []
					if(res.code == 0){
						this.productList = res.data
					}
				})
			},
			del_selection_category_goods(item){
				let params = {
					act:'del_selection_category_goods',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					s_g_id: item.s_g_id,
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.get_enterprise_selection_category()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			save_selection_category_goods(){
				let arr = []
				this.zxGoods.forEach((item)=>{
					if(item.checked){
						arr.push(item.goods_id)
					}
				})
				let params = {
					act:'save_selection_category_goods',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					cat_id: this.curZx.cat_id,
					goods_ids: arr.join(',')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						if(res.code == 0){
							this.$message({
								showClose: false,
								message: '操作成功',
								type: 'success',
								offset: 350,
								duration: 1500
							})
							this.goodsStatus = false
							this.get_enterprise_selection_category()
						}else{
							this.$message({
								showClose: false,
								message: res.msg,
								type: 'error',
								offset: 350,
								duration: 1500
							})
						}
					}
				})
			},
			enterprise_goods_list_zx(val){
				this.curZx = val
				let params = {
					act:'get_selection_category_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					status: 1,
					parent_id: val.parent_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.zxGoods = []
					res.data.forEach((item)=>{
						this.zxGoods.push({checked:false,...item})
					})
					this.goodsStatus = true
				})
			},
			addOne(){
				this.category_data.push({
					cat_id:0,
					cat_name:'',
					show:true,
					child:[]
				})
			},
			delOne(index,item){
				if(!item.cat_id){
					this.category_data.splice(index,1)
					return
				}
				this.$msgbox.confirm('是否删除该分类?(分类下如有产品将不能删除)', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning',
				  center: true
				}).then(() => {
				  let params = {
				  	act:'del_enterprise_selection_category',
				  	token: localStorage.getItem('token'),
				  	user_id: localStorage.getItem('user_id'),
				  	cat_id: item.cat_id,
				  }
				  this.$api.publicity_manage_api(params).then((res)=>{
					  if(res.code == 0){
					  	this.$message({
					  		showClose: false,
					  		message: '删除成功',
					  		type: 'success',
					  		offset: 350,
					  		duration: 1500
					  	})
						this.category_data.splice(index,1)
						this.get_enterprise_selection_category()
					  }else{
					  	this.$message({
					  		showClose: false,
					  		message: res.msg,
					  		type: 'error',
					  		offset: 350,
					  		duration: 1500
					  	})
					  }
				  })
				})				
			},
			addTwo(item){
				item.child.push({
					cat_id:0,
					cat_name:''
				})
			},
			delTwo(item,index){
				if(!item.child[index].cat_id){
					item.child.splice(index,1)
					return
				}
				this.$msgbox.confirm('是否删除该分类?(分类下如有产品将不能删除)', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning',
				  center: true
				}).then(() => {
				  let params = {
				  	act:'del_enterprise_selection_category',
				  	token: localStorage.getItem('token'),
				  	user_id: localStorage.getItem('user_id'),
				  	cat_id: item.child[index].cat_id,
				  }
				  this.$api.publicity_manage_api(params).then((res)=>{
					  if(res.code == 0){
					  	this.$message({
					  		showClose: false,
					  		message: '删除成功',
					  		type: 'success',
					  		offset: 350,
					  		duration: 1500
					  	})
						item.child.splice(index,1)
						this.get_enterprise_selection_category()
					  }else{
					  	this.$message({
					  		showClose: false,
					  		message: res.msg,
					  		type: 'error',
					  		offset: 350,
					  		duration: 1500
					  	})
					  }
				  })
				})
				
			},
			save_enterprise_selection_category(){
				let status = false //判断数组内是否有可以删除的商品状态
				
				this.category_data.forEach((item)=>{
					if(item.cat_name == ''){
						status = true
						return
					}
					item.child.forEach((val)=>{
						if(val.cat_name == ''){
							status = true
							return
						}
					})
				})
				if(status){
					this.$message({
						showClose: false,
						message: '分类内容不能为空',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				let params = {
					act:'save_enterprise_selection_category',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					category_data: JSON.stringify(this.category_data),
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '保存成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.category = false
						this.get_enterprise_selection_category()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			setColorAndTxt(){
				let dearr = []
				this.view.forEach((item, index) => {
					if (item.options.user_decor_module_id) {
						dearr.push({
							decor_module_id: item.options.decor_module_id,
							user_decor_module_id: item.options.user_decor_module_id,
							sort: index + 1,
						})
					}
				})
				let params = {
					act:'co_gpe_index_module_save',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					colour_code:this.colour_code,
					colour_words:this.colour_words,
					decor_user_module_json_data: JSON.stringify(dearr),
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '修改成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
					this.setColor = false
				})
			},
			setAll(status){
				this.qyspGoodsList.forEach((item)=>{
					item.checked = status
				})
			},
			openTgDetail(item){
				this.tgDetail = true
				let params = {
					act:'get_spread_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					spread_id: item.spread_id,
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					this.spreadInfo = res.data
				})
			},
			add_spread_info(){
				if(this.spread_type == 0 && this.target_num == '' ){
					this.$message({
						showClose: false,
						message: '请输入阅览次数',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				let arr = []
				if(this.spread_type == 0){
					arr.push({
						type:0,
						type_id:localStorage.getItem('ru_id'),
						target_num:this.target_num
					})
				}else{
					this.goodsList.forEach((item)=>{
						if(item.checked && item.target_num){
							arr.push({
								type:1,
								type_id:item.id,
								target_num:item.target_num
							})
						}
					})
					this.busList.forEach((item)=>{
						if(item.checked && item.target_num){
							arr.push({
								type:2,
								type_id:item.id,
								target_num:item.target_num
							})
						}
					})
					this.activiList.forEach((item)=>{
						if(item.checked && item.target_num){
							arr.push({
								type:3,
								type_id:item.activity_id,
								target_num:item.target_num
							})
						}
					})
				}
				if(arr.length == 0){
					this.$message({
						showClose: false,
						message: '请添加一条数据，且阅览次数不能为空',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				let ids = []
				this.sel_tgy_list.forEach((item)=>{
					if(item.checked){
						ids.push(item.s_m_id)
					}
				})
				if(ids.length==0){
					this.$message({
						showClose: false,
						message: '请选择人员',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				let params = {
					act:'add_spread_info_v2',
					add_type:this.add_type,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					spread_id:this.spread_id,
					note:'',
					s_m_ids:ids.join(','),
					// name:this.name,
					// mobile:this.mobile,
					// region:this.region,
					// micro_mobile:this.micro_mobile,
					spread_type:this.spread_type,
					spread_data:JSON.stringify(arr),
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.spread_id = ''
						this.name = ''
						this.mobile = ''
						this.region = ''
						this.micro_mobile = ''
						this.tgState = false
						this.get_spread_list(0)
						this.get_spread_list(1)
						this.$message({
							showClose: false,
							message: '保存成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			get_spread_list(status){
				let params = {
					act:'get_spread_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status:status,
					size:99,
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(status == 1||status == 2){
						this.spread_list  = []
						this.spread_list = res.data
					}
					if(status == 0){
						this.sq_spread_list = []
						this.sq_spread_list = res.data
					}
				})
			},
			//获取产品服务
			co_gpe_activity(){
				let params = {
					act:'co_gpe_activity_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					activity_status:1,
					size:99,
					keyword:this.goodsKeyword
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.activiList = []
						res.data.forEach((item)=>{
							this.activiList.push({...item,target_num:'',checked:false})
						})
					}
				})
			},
			//获取企业动态
			get_enterprise_dynamic_list(){
				let params = {
					act:'get_enterprise_dynamic_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
					size:99,
					keyword:this.businessKeyword,
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.busList = []
						res.data.forEach((item)=>{
							this.busList.push({...item,target_num:'',checked:false})
						})
					}
				})
			},
			//产品列表
			enterprise_goods_list(){
				let params = {
					act:'enterprise_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status: 1,
					page: 1,
					size: 99
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.goodsList = []
						res.data.forEach((item,index)=>{
							this.goodsList.push({...item,target_num:'',checked:false})
						})
					}
				})
			},
			co_gpe_activity_info(item){
				let params = {
					act: 'co_gpe_activity_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					activity_id: item.activity_id
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.activity_id = item.activity_id
						this.hdIndex = res.data.source
						this.wzTitle = res.data.title
						this.cover = res.data.cover
						if(this.hdIndex == 0){
							this.dyList = res.data.content
						}else{
							this.wzContents = res.data.content
						}
						let start_time = new Date(res.data.start_time * 1000)
						let stm = start_time.getFullYear()+'-'+(start_time.getMonth()+1)+'-'+start_time.getDate()+' 00:00'
						let end_time = new Date(res.data.end_time * 1000)
						let etm = end_time.getFullYear()+'-'+(end_time.getMonth()+1)+'-'+end_time.getDate()+' 00:00'
						this.start_time = stm
						this.end_time = etm
						this.join_users = res.data.join_users
					}
				})
			},
			setIndex(index){
				this.tabIndex = index
				if(this.tabIndex==7){
					this.get_bu_shop_list()
					this.get_relation_bu_shop_list()
				}
			},
			co_gpe_rco_add(){
				let arr = []
				this.companyList.forEach((item)=>{
					if(item.checked && item.co_code != ''){
						arr.push({rco_id:item.rco_id,co_code:item.co_code})
					}
				}) 
				if(arr.length == 0){
					this.$message({
						showClose: false,
						message: '未选择企业或未输入编号',
						type: 'error',
						offset: 350,
						duration: 1500
					})
					return
				}
				let params = {
					act: 'co_gpe_rco_add',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					json_data: JSON.stringify(arr)	
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.co_branch_office_list()
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			setCid(item){
				this.companyList.forEach((val)=>{
					val.checked = false
				})
				item.checked = true
			},
			co_branch_office_del(item){
				let params = {
					act: 'co_branch_office_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					bo_id: item.bo_id
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.co_branch_office_list()
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			co_branch_office_list(){
				let params = {
					act: 'co_branch_office_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99
				}
				this.$api.get_company_info(params).then((res)=>{
					this.companyData = []
					if(res.code == 0){
						this.companyData = res.data
					}
				})
			},
			co_gpe_rco_list(){
				let params = {
					act: 'co_gpe_rco_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					company_name: this.company_name,
					size:99
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.companyList = []
						res.data.forEach((item)=>{
							this.companyList.push({...item,checked:false,co_code:''})
						})
						
					}
				})
			},
			co_gpe_certificate_del(item){
				let params = {
					act: 'co_gpe_certificate_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					certificate_id: item.certificate_id
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.co_gpe_certificate_list()
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			co_gpe_certificate_list(){
				let params = {
					act: 'co_gpe_certificate_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99
				}
				this.$api.get_company_info(params).then((res)=>{
					this.zzList = []
					if(res.code == 0){
						this.zzList = res.data
					}
				})
			},
			fileSuccess(res){
				
				res.data.upload_data.forEach((item)=>{
					let params = {
						act: 'co_gpe_certificate_add',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						cc_ids: item.cc_id
					}
					this.$api.get_company_info(params).then((res)=>{
						if(res.code == 0){
							this.co_gpe_certificate_list()
						}
					})
				})
				
			},
			setGoods(item){
				item.checked = !item.checked
			},
			cancelTeam(){
				this.wzTitle = ''
				this.cover = ''
				this.team_id = ''
				this.dyList = []
				this.wzContents = ''
				this.cgalList = []
			},
			co_gpe_team_module_save(){
				let arr = []
				this.cgalList.forEach((item)=>{
					if(item.checked){
						arr.push(item.case_id)
					}
				})
				let params = {
					act: 'co_gpe_team_module_save',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					team_id:this.team_id,
					title:this.wzTitle,
					cover:this.cover,
					content:this.tdIndex==0?this.dyList:this.wzContents,
					source:this.tdIndex,
					case_ids:arr.join(',')
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.wzTitle = ''
						this.cover = ''
						this.team_id = ''
						this.dyList = []
						this.wzContents = ''
						this.cgalList = []
						this.co_gpe_team_module_list()
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			cance_gpe_activity(){
				this.start_time = ''
				this.end_time = ''
				this.activity_id = ''
				this.wzTitle = ''
				this.wzContents = ''
				this.dyList = []
				this.cover = ''
				this.join_users = []
			},
			co_gpe_activity_save(){
				let start_time = new Date(this.start_time)
				let stm = start_time.getFullYear()+'-'+(start_time.getMonth()+1)+'-'+start_time.getDate()+' 00:00'
				let end_time = new Date(this.end_time)
				let etm = end_time.getFullYear()+'-'+(end_time.getMonth()+1)+'-'+end_time.getDate()+' 00:00'

				let params = {
					act: 'co_gpe_activity_save',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					activity_id:this.activity_id,
					title:this.wzTitle,
					cover:this.cover,
					content:this.hdIndex==0?this.dyList:this.wzContents,
					source:this.hdIndex,
					start_time:stm,
					end_time:etm
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.cover = ''
						this.wzTitle = ''
						this.activity_id = ''
						this.dyList = []
						this.wzContents = ''
						this.co_gpe_activity_list()
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			cancelCase(){
				this.case_id = ''
				this.wzTitle = ''
				this.cover = ''
				this.dyList = []
				this.wzContents = ''
			},
			co_gpe_case_save(){
				let params = {
					act: 'co_gpe_case_save',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					case_id:this.case_id,
					title:this.wzTitle,
					cover:this.cover,
					content:this.alIndex==0?this.dyList:this.wzContents,
					source:this.alIndex
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.case_id = ''
						this.wzTitle = ''
						this.cover = ''
						this.dyList = []
						this.wzContents = ''
						this.co_gpe_case_list()
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			co_gpe_team_module_info(item){
				let params = {
					act: 'co_gpe_team_module_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					team_id:item.team_id
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.team_id = res.data.team_id
						this.cover = res.data.cover
						this.tdIndex = res.data.source
						this.wzTitle = res.data.title
						if(this.tdIndex == 0){
							this.dyList = res.data.content
						}else{
							this.wzContents = res.data.content
						}
						this.cgalList.forEach((item,index)=>{
							res.data.case_list.forEach((val)=>{
								if(item.case_id == val.case_id){
									this.cgalList[index].checked = true
								}
							})
						})
					}
				})
			},
			co_gpe_case_info(item){
				let params = {
					act: 'co_gpe_case_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					case_id:item.case_id
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.case_id = res.data.case_id
						this.cover = res.data.cover
						this.alIndex = res.data.source
						this.wzTitle = res.data.title
						if(this.alIndex == 0){
							this.dyList = res.data.content
						}else{
							this.wzContents = res.data.content
						}
					}
				})
			},
			co_gpe_team_module_change(item,type){
				let params = {
					act: 'co_gpe_team_module_change',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					team_id:item.team_id,
					change_type:type
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.tdList = []
						this.co_gpe_team_module_list()
					}
				})
			},
			fcib_activity_del(item){
				let params = {
					act: 'co_gpe_activity_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					activity_id:item.activity_id
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.hdList = []
						this.co_gpe_activity_list()
					}
				})
			},
			co_gpe_case_change(item,type){
				let params = {
					act: 'co_gpe_case_change',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					case_id:item.case_id,
					change_type:type
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.alList = []
						this.co_gpe_case_list()
					}
				})
			},
			sethdStatus(status){
				this.hdStatus = status
				this.hdList = []
				this.co_gpe_activity_list()
			},
			setalStatus(status){
				this.alStatus = status
				this.alList = []
				this.co_gpe_case_list()
			},
			settdStatus(status){
				this.tdStatus = status
				this.tdList = []
				this.co_gpe_team_module_list()
			},
			co_gpe_activity_list(){
				let params = {
					act: 'co_gpe_activity_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					activity_status: this.hdStatus,
					size: 99
				}
				this.$api.get_company_info(params).then((res) => {
					this.hdList = []
					if(res.code == 0){
						this.hdList = res.data
					}
				})
			},
			co_gpe_team_module_list(){
				let params = {
					act: 'co_gpe_team_module_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					info_status:this.tdStatus,
					size:99
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.tdList = res.data
					}
				})
			},
			co_gpe_case_list_sel(){
				let params = {
					act: 'co_gpe_case_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					info_status:this.alStatus,
					size:99
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.cgalList = []
						res.data.forEach((item,index)=>{
							this.cgalList.push({...item,checked:false})
						})
					}
				})
			},
			co_gpe_case_list(){
				let params = {
					act: 'co_gpe_case_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					info_status:this.alStatus,
					size:99
				}
				this.$api.get_company_info(params).then((res) => {
					if(res.code == 0){
						this.alList = res.data
					}
				})
			},
			//上移简介图片
			upFiles(){
				if(this.dyIndex === 0||this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex-1,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex+1,1)
				this.dyIndex--
			},
			//下移简介图片
			dowFiles(){
				if(this.dyIndex === (this.dyList.length-1) || this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex+2,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex++
			},
			//删除简介图片
			delfiles(){
				if(!this.dyList.length){
					return
				}
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex = ''
			},
			//获取封面
			getImg(file, fileList){
				this.getBase64(file.raw).then((res) => {
					this.cover = res
				})
			},
			setcenter(){
				if(this.dyList[this.dyIndex].type == 1){
					this.dyList[this.dyIndex].type = 3
				}else if(this.dyList[this.dyIndex].type == 3){
					this.dyList[this.dyIndex].type = 1
				}
			},
			setTxt(){
				this.dyList.push({type:1,content:this.txt})
				this.txt = ''
				this.txtShow = false
			},
			getLiveDylist(file, fileList) {
				this.dyList.push({type:2,content:file.data})
			},
			setTabIndex(index) {
				this.tabIndex = index
				this.wzContents = ''
				this.dyIndex = ''
				this.dyList = []
				this.wzTitle = ''
				this.cover = ''
				this.case_id = ''
				this.team_id = ''
				this.activity_id = ''
				this.end_time = ''
				this.start_time = ''
				this.join_users = []
				if(index == 1){
					this.co_gpe_activity()
					this.enterprise_goods_list()
					this.get_enterprise_dynamic_list()
					this.get_spread_list(0)
					this.get_spread_list(1)
					this.spread_member_list()
				}
				if(index == 2){
					this.co_branch_office_list()
					this.co_gpe_rco_list()
					
				}
				if(index == 3){
					this.co_gpe_activity_list()
				}
				if(index == 4){
					this.co_gpe_certificate_list()
				}
				if(index == 5){
					this.co_gpe_case_list_sel()
					this.co_gpe_team_module_list()
				}
				if(index == 6){
					this.co_gpe_case_list()
				}
				if(index == 7){
					this.get_bu_shop_list()
					this.get_relation_bu_shop_list()
				}
				if(index == 8){
					this.get_bu_group_member_list()
					this.business_intro_name()
					this.get_bu_group_total_num()
				}
				if(index == 9){
					this.get_selection_goods_list()
					this.get_enterprise_selection_category()
				}
				if(index == 10){
					this.admin_get_bu_contact_qr_code_list()
				}
			},
			get_enterprise_selection_category(){
				let params = {
					act: 'get_enterprise_selection_category',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					get_data: 1
				}
				this.$api.publicity_manage_api(params).then((res) => {
					if(res.code == 0){
						this.category_data = []
						this.categoryData = []
						res.data.forEach((item,index)=>{
							this.category_data.push({...item,show:true})
							this.categoryData.push({...item,show:true})
							let arr = []
							item.child.forEach((val,key)=>{
								arr.push({...val,show:true})
							})
							this.categoryData[index].child = arr
						})
					}
				})
			},
			bu_group_admin_set(item){
				let params = {
					g_member_id:item.g_member_id
				}
				this.$api.bu_group_admin_set(params).then((res) => {
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '设定成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.get_bu_group_member_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.get_bu_group_member_list()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.get_bu_group_member_list()
			},
			get_bu_group_member_list(){
				let params = {
					act: 'get_bu_group_member_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					keyword:this.groupKeyword,
					page:this.currentPage,
					size:this.pageSize
				}
				this.$api.publicity_manage_api(params).then((res) => {
					this.tableData = []
					this.total_records = 0
					if (res.code == 0) {
						this.tableData = res.data
						this.total_records = res.total_records
					}
				})
			},
			get_bu_group_total_num(){
				let params = {
					act: 'get_bu_group_total_num',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.publicity_manage_api(params).then((res) => {
					if (res.code == 0) {
						this.groupTotal = res.data
					}
				})
			},
			business_intro_name(name) {
				let params = {
					act: 'business_intro',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
				}
				this.$api.business_intro(params).then((res) => {
					if (res.code == 0) {
						this.businessInfo = res.data.business_info
					}
				})
			},
			setQyspItem(item){
				console.log(item);
				let params = {
					act: 'get_bu_shop_goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					bu_shop_id: item.bu_shop_id,
				}
				this.$api.get_company_info(params).then((res)=>{
					this.qyspGoodsList = []
					if(res.code == 0){
						res.data.forEach((item)=>{
							this.qyspGoodsList.push({...item,checked:false})
						})
					}
					this.qysp = true
					this.qyspItem = item
				})
				
			},
			ctrl_relation_bu_shop(item,ctrl){
				let arr = []
				if(ctrl == 3){
					this.qyspGoodsList.forEach((item)=>{
						if(item.checked){
							arr.push(item.goods_id)
						}
					})
				}
				let params = {
					act: 'ctrl_relation_bu_shop',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ctrl: ctrl,
					rs_id: ctrl==3?this.qyspItem.rs_id:item.rs_id,
					goods_ids:arr.join(',')
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.get_bu_shop_list()
						this.get_relation_bu_shop_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
					this.qysp = false
				})
			},
			verify_bu_shop_info(){
				let arr = []
				this.shopList.forEach((item)=>{
					if(item.checked && item.mobile){
						arr.push({shop_id:item.bu_shop_id,shop_name:item.bu_shop_name,mobile:item.mobile})
					}
				})
				if(!arr.length){
					return
				}
				let params = {
					act: 'verify_bu_shop_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					verify_data: JSON.stringify(arr)
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'success',
							offset: 350,
							duration: 1500
						})
						this.get_bu_shop_list()
						this.get_relation_bu_shop_list()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			get_relation_bu_shop_list(){
				let params = {
					act: 'get_relation_bu_shop_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
				}
				this.$api.get_company_info(params).then((res)=>{
					this.bd_shopList = []
					if(res.code == 0){
						this.bd_shopList = res.data
					}
				})
			},
			get_bu_shop_list(){
				let params = {
					act: 'get_bu_shop_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					keyword: this.shopKeyword
				}
				this.$api.get_company_info(params).then((res)=>{
					this.shopList = []
					if(res.code == 0){
						res.data.forEach((item)=>{
							this.shopList.push({...item,checked:false,mobile:''})
						})
					}
				})
			},
			co_gpe_decor_module_list() {
				let params = {
					act: 'co_gpe_decor_module_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					
				})
			},
			co_gpe_index_module_get() {
				let params = {
					act: 'co_gpe_index_module_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res) => {
					if (res.code == 0) {
						this.module_list = res.data.module_list
						this.module_style_type = res.data.module_style_type
						if (res.data.module_style_type == 1) {
							this.background[0].color = res.data.colour_code
						}
					}
					//轮播广告
					this.co_gpe_carousel_ad_get()
				})
			},
			co_gpe_carousel_ad_get() {
				let params = {
					act: 'co_gpe_carousel_ad_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res) => {
					if (res.code == 0) {
						this.adlist = []
						res.data.carousel_ad_list.forEach((item) => {
							this.adlist.push({
								...item,
								type: res.data.carousel_ad_type
							})
						})
						this.co_gpe_cinj_get()
					}
				})
			},
			//介绍信息获取
			co_gpe_cinj_get() {
				let params = {
					act: 'co_gpe_cinj_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res) => {
					if (res.code == 0) {
						this.cinj = []
						if (res.data.gpe_cinj_type == 4 && res.data.user_module_name) {
							this.business_intro(res.data.user_module_name)
						} else if (res.data.gpe_cinj_type == 5 && res.data.user_module_name) {
							this.cinj.push({
								gpe_cinj_type: 5,
								source: res.data.cinj_info.source,
								content: res.data.cinj_info.content,
								user_module_name: res.data.user_module_name || '企业介绍',
								is_template: ''
							})
						}
					}
					this.co_gpe_paas_get()
				})
			},
			//产品信息
			co_gpe_paas_get() {
				let params = {
					act: 'co_gpe_paas_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res) => {
					if (res.code == 0) {
						this.paas = []
						res.data.goods_list.forEach((item, index) => {
							this.paas.push({
								user_module_name: res.data.user_module_name,
								gpe_paas_type: res.data.gpe_paas_type,
								goods_id: item.item,
								sort: index + 1,
								img: item.goods_thumb,
							})
						})
					}
					this.co_gpe_activity_get()
				})
			},
			//活动类
			co_gpe_activity_get() {
				let params = {
					act: 'co_gpe_activity_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res) => {
					if (res.code == 0) {
						this.activityList = []
						this.activityList = res.data.activity_list
					}
				})
				this.co_gpe_dynamic_get()
			},
			//动态
			co_gpe_dynamic_get(){
				let params = {
					act:'co_gpe_dynamic_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.dynamic_list = []
						res.data.dynamic_list.forEach((item,index)=>{
							if(/\.(jpg|jpeg|png|GIF|JPG|PNG)$/.test(item.cover)){
								this.dynamic_list.push({img:item.cover,sort:index+1,doc_id:item.doc_id,type:0,title:item.title})
							}else{
								this.dynamic_list.push({img:item.cover,sort:index+1,doc_id:item.doc_id,type:1,title:item.title})
							}
						})
						this.dynname = res.data.user_module_name
					}
					this.get_spread_show()
				})
			},
			//推广
			get_spread_show(){
				let params = {
					act:'get_spread_show',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.spread = {
							user_module_name:res.data.user_module_name||'推广类',
							main_title:res.data.main_title,
							sub_title:res.data.sub_title,
							show_name:res.data.show_name==1?true:false,
							show_mobile:res.data.show_mobile==1?true:false,
							show_region:res.data.show_region==1?true:false,
							show_note:res.data.show_note==1?true:false,
						}
					}
					this.co_gpe_team_get()
				})
			},
			co_gpe_team_get(){
				let params = {
					act:'co_gpe_team_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0 ){
						this.teamoptions = {
							user_module_name:res.data.user_module_name
						}
						this.teamList = res.data.team_list
					}
					this.co_gpe_certificate_get()
				})
			},
			co_gpe_certificate_get(){
				let params = {
					act:'co_gpe_certificate_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.creoptions = {
							user_module_name:res.data.user_module_name||'资质类'
						}
						this.cerlist = res.data.certificate_list
					}
					this.co_gpe_branch_office_get()
				})
			},
			co_gpe_branch_office_get(){
				let params = {
					act:'co_gpe_branch_office_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.branchoptions = {
							user_module_name:res.data.user_module_name||'子公司/分公司类'
						}
						this.branchlist = res.data.branch_office_list
					}
					this.co_gpe_user_case_get()
				})
			},
			co_gpe_user_case_get(){
				let params = {
					act:'co_gpe_user_case_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.caseOptions = {
							user_module_name:res.data.user_module_name||'案例类'
						}
						this.caseList = res.data.case_list
					}
					this.co_gpe_product_class_get()
					
				})
			},
			co_gpe_product_class_get(){
				let params = {
					act:'co_gpe_product_class_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0 ){
						this.productOptions = {
							user_module_name:res.data.user_module_name||'产品/服务分类'
						}
						this.cpfwfl = res.data.goods_cat_list
					}
					this.co_gpe_env_intro_get()
					
				})
			},
			co_gpe_env_intro_get(){
				let params = {
					act:'co_gpe_env_intro_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0 ){
						if(res.data.env_intro){
							this.hjcjOptions = {
								user_module_name:res.data.user_module_name||'环境场景类',
								content:res.data.env_intro.content,
								source:res.data.env_intro.source
							}
						}
					}
					this.co_gpe_all_items_get()
					
				})
			},
			co_gpe_all_items_get(){
				let params = {
					act:'co_gpe_all_items_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0 ){
						this.allOptions = {
							user_module_name:res.data.user_module_name||'全部项目'
						}
						this.allList = res.data.goods_list
					}
					this.get_bu_shop()
				})
			},
			get_bu_shop(){
				let params = {
					act:'get_bu_shop',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0 ){
						this.shopNmae = res.data.user_module_name
					}
					this.get_relation_bu_shop_list_2()
				})
			},
			get_relation_bu_shop_list_2(){
				let params = {
					act:'get_relation_bu_shop_list',
					business_id: localStorage.getItem('ru_id'),
				}
				this.$api.get_relation_bu_shop_list(params).then((res)=>{
					if(res.code == 0 ){
						this.bu_shop_list = res.data
					}
					this.get_bu_circle()
				})
			},
			get_bu_circle(){
				let params = {
					act:'get_bu_circle',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						this.circleOptions = {
							user_module_name:res.data.user_module_name||'企业圈',
							alias_a:res.data.alias_a,
							alias_b:res.data.alias_b,
							alias_c:res.data.alias_c,
							alias_d:res.data.alias_d,
							alias_e:res.data.alias_e
						}
					}
					this.co_ba_gpe_selection_get()
					
				})
			},
			//获取活动类
			co_ba_gpe_selection_get(){
				let params = {
					act:'co_ba_gpe_selection_get',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code == 0 ){
						this.selectionOptions = res.data.user_module_name||''
						this.selection = res.data.goods_list
					}
					this.sortDta()
				})
			},
			sortDta() {
				let params = {
					act: 'admin_get_bu_zxb_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.admin_get_bu_zxb_info(params).then((res) => {
					if(res.code == 0){
						this.colour_code = res.data.bg_color
						if(res.data.goods_list && res.data.goods_list.length!=0){
							let arr=[]
							res.data.goods_list.forEach((v)=>{
								arr.push({
									goods_id:v.goods_id,
									gpe_paas_type:res.data.goods_show_type==1?6:res.data.goods_show_type==2?7:res.data.goods_show_type==3?8:res.data.goods_show_type==4?9:10,
									img:v.goods_img,
									user_module_name:'产品/服务'
								})
							})
							this.view.push({
								type: 'product',
								status: false,
								data: arr,
								options: {
									decor_module_id:4,
									user_decor_module_id:571
								}
							})
						}
						if(res.data.intro_content){
							let arr1=[]
							arr1.push({
								content:res.data.intro_content.content,
								gpe_cinj_type:res.data.intro_content.content_type==0?4:5,
								user_module_name:res.data.qy_intro_name,
								is_template: 2,
								source: 0
							})
							this.view.push({
								type: 'introduce',
								status: false,
								data: arr1,
								options: {
									decor_module_id:3,
									user_decor_module_id:572
								}
							})
						}
						console.log(this.view);
						// res.data.decor_user_module_list.forEach((item)=>{
						// 	if(item.decor_module_id == 3){
						// 		if (this.cinj.length) {
						// 			this.view.push({
						// 				type: 'introduce',
						// 				status: false,
						// 				data: this.cinj,
						// 				options: {
						// 					decor_module_id:item.decor_module_id,
						// 					user_decor_module_id:item.user_decor_module_id
						// 				}
						// 			})
						// 		}
						// 	}else if(item.decor_module_id == 4){
						// 		if (this.paas.length) {
									
						// 		}
						// 	}else if(item.decor_module_id == 16){
						// 		if (this.shopNmae != '') {
						// 			this.view.push({
						// 				type: 'entsp',
						// 				status: false,
						// 				data: this.bu_shop_list,
						// 				options: {
						// 					decor_module_id:item.decor_module_id,
						// 					user_decor_module_id:item.user_decor_module_id,
						// 					user_module_name:this.shopNmae||'联系我们'
						// 				}
						// 			})
						// 		}
						// 	}
						// })
					}
				})
			},
			//获取企业介绍
			business_intro(name) {
				let params = {
					act: 'business_intro',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
				}
				this.$api.business_intro(params).then((res) => {
					if (res.code == 0) {
						this.cinj.push({
							gpe_cinj_type: 4,
							source: 0,
							content: '',
							user_module_name: name || '企业介绍',
							is_template: ''
						})
						this.cinj[0].gpe_cinj_type = 4
						this.cinj[0].is_template = res.data.is_template
						this.cinj[0].content = res.data.business_intro
					}
				})
			},
			submit() {
				// JSON 转换会丢失 formData
				const form = JSON.parse(JSON.stringify(this.view))
				console.log(form);
				return
				if (form.length == 1) {
					this.$message.error('请添加模块！')
					return
				}

				for (let i of form) {
					if (i.data && i.data.length == 0) {
						this.$message.error('请填写完整信息！')
						return
					}
					if (i.type === 'product') {
						i.data = i.data.map(val => val.productId).join(',')
					}
				}

				this.$message.success('数据提交成功，请按F12打开控制台查看待提交数据集合！')

				console.log(form) // 提交的数据，根据接口形式修改

				return

				// 上传图片，修改数据字段（兼容接口
				const uploadPromise = {}
				for (let i = 0; i < this.view.length; i++) {
					if (['images', 'banner'].includes(this.view[i].type)) {
						uploadPromise[i] = []
						let list = this.view[i]['data']
						list.forEach((item, index) => {
							uploadPromise[i].push(
								new Promise((resolve, reject) => {
									const link = item.link
									const name = item.name
									imageUpload(item.form).then(res => { // 上传图片接口
										form[i]['data'][index] = {
											url: res.data.url,
											link,
											name
										}
										resolve(res)
									}).catch(err => {
										reject(err)
									})
								})
							)
						})
					}
				}

				let [len, count] = [Object.keys(uploadPromise).length, 0]
				if (len) {
					for (let i in uploadPromise) {
						Promise.all(uploadPromise[i]).then(res => {
							count++
							if (count === len) {
								// 提交数据
							}
						}).catch(err => {
							this.$message.error(err)
						})
					}
				} else {
					// 提交数据
				}
			},
			// 切换视图组件
			selectType(index) {
				this.isRight = false
				this.props = this.view[index]
				this.$nextTick(() => this.isRight = true)
			},
			deleteItem(e, index) {
				if(!this.view[index].options.user_decor_module_id){
					e.preventDefault()
					e.stopPropagation()
					this.view.splice(index, 1)
					this.isRight = false
					this.props = {}
					return
				}
				let params = {
					act:'co_gpe_decor_user_module_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					user_decor_module_id:this.view[index].options.user_decor_module_id,
					decor_module_id:this.view[index].options.decor_module_id
				}
				this.$api.publicity_manage_api(params).then((res)=>{
					if(res.code == 0){
						e.preventDefault()
						e.stopPropagation()
						this.view.splice(index, 1)
						this.isRight = false
						this.props = {}
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			},
			// 拖拽类型
			dragStart(e) {
				this.type = e.target.dataset.type
				console.log(this.type);
			},
			// 结束拖拽
			dragEnd(e) {
				this.$delete(this.view[this.index], 'status')
				this.isPush = false
				this.type = null
			},
			// 已放置到指定位置
			drog(e) {
				console.log(this.type);
				if (!this.type) { // 内容拖拽
					setTimeout(()=>{
						let dearr = []
						this.view.forEach((item,index)=>{
							if(item.options.user_decor_module_id){
								dearr.push({
									decor_module_id:item.options.decor_module_id,
									user_decor_module_id:item.options.user_decor_module_id,
									sort:index+1,
								})
							}
						})
						let params = {
							act: 'co_gpe_index_module_get',
							token: localStorage.getItem('token'),
							user_id: localStorage.getItem('user_id'),
						}
						this.$api.publicity_manage_api(params).then((res)=>{
							if(res.code == 0){
								let par = {
									act:'co_gpe_index_module_save',
									token: localStorage.getItem('token'),
									user_id: localStorage.getItem('user_id'),
									index_module_json_data:JSON.stringify(res.data.module_list),
									decor_user_module_json_data:JSON.stringify(dearr),
									module_style_type:1,
									colour_code:res.data.colour_code
								}
								this.$api.publicity_manage_api(par)
							}
						})
					},100)
					
					return
				}
				e.preventDefault()
				e.stopPropagation()
				this.dragEnd()
				
			},
			// 移动中
			dragOver(e) {
				let status = false
				this.view.forEach((item) => {
					if (this.type == item.type) {
						status = true
					}
				})
				if (status) {
					return
				}
				if (!this.type) {
					return
				}
				e.preventDefault()
				e.stopPropagation()
				let className = e.target.className
				let name = className !== 'view-content' ? 'item' : 'view-content'

				const defaultData = {
					type: this.type, // 组件类型
					status: 2, // 默认状态
					data: [], // 数据
					options: {} // 选项操作
				}
				console.log(defaultData);
				if (name == 'view-content') {
					if (!this.isPush) {
						this.index = this.view.length
						this.isPush = true
						this.view.push(defaultData)
					}
				} else if (name == 'item') {

					let target = e.target
					let [y, h, curIndex] = [e.offsetY, target.offsetHeight, target.dataset.index]
					let direction = y < (h / 2)

					if (!this.isPush) {
						// Push to Top or Bottom
						if (direction) {
							if (curIndex == 0) {
								this.view.unshift(defaultData)
							} else {
								this.view.splice(curIndex, 0, defaultData)
							}
						} else {
							curIndex = +curIndex + 1
							this.view.splice(curIndex, 0, defaultData)
						}
					} else {
						// Moving
						if (direction) {
							var i = curIndex == 0 ? 0 : curIndex - 1
							var result = this.view[i]['status'] == 2
						} else {
							var i = +curIndex + 1
							var result = this.view.length > i && this.view[i]['status'] == 2
						}

						if (result) return

						const temp = this.view.splice(this.index, 1)
						this.view.splice(curIndex, 0, temp[0])
					}
					this.index = curIndex
					this.isPush = true
				}
			},
			//返回base64
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			checkImgType(fileName) { //判断是否是图片
			  //用文件名name后缀判断文件类型，可用size属性判断文件大小不能超过500k ， 前端直接判断的好处，免去服务器的压力。 
			  if (!/\.(jpg|jpeg|png|GIF|JPG|PNG)$/.test(fileName)) {
			    return false;
			  } else {
			    return true;
			  }
			},
			admin_save_bu_zxb_info(){
				console.log(this.view);
				let ids=[]
				let curpasstype=0
				let qy_intro_name=''
				let intro_type=0
				let intro_content=[]
				this.view.forEach((v)=>{
					if(v.type=='product'){
						v.data.forEach((v1)=>{
							ids.push(v1.goods_id)
							curpasstype=v1.gpe_paas_type
						})
					}else if(v.type=='introduce'){
						qy_intro_name=v.data[0].user_module_name
						intro_type=v.data[0].gpe_cinj_type==4?0:1
						intro_content=v.data[0].content
					}
				})
				let params={
					act:'admin_save_bu_zxb_info',
					bg_color:this.colour_code,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					goods_show_type:curpasstype==6?1:curpasstype==7?2:curpasstype==8?3:curpasstype==9?4:5,
					goods_ids:ids.join(','),
					qy_intro_name:qy_intro_name,
					intro_type:intro_type,
					intro_content:JSON.stringify(intro_content),
					cooperation_name:'联系我们'
				}
				this.$api.admin_save_bu_zxb_info(params).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '发布成功',
							type: 'success',
							offset: 350,
							duration: 1500
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 1500
						})
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.text-hide-2{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	.goodsStatus::after{
		width: 258px;
		content: '';
	}
	.hvbg:hover{
		background: rgba(30, 105, 255, 0.2);
	}
	.thd{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.number input::-webkit-inner-spin-button {
	    -webkit-appearance: none!important;
	}
	.tg-box::-webkit-scrollbar{
		display: none;
	}
	.hdbox::-webkit-scrollbar{
		display: none;
	}
	.l::-webkit-scrollbar{
		display: none;
	}
	.r::-webkit-scrollbar{
		display: none;
	}
	.fsgx::-webkit-scrollbar{
		display: none;
	}
	.tgcpfw-box::after{
		content: '';
		width: 360px;
	}
	.fsgx::after{
		content: '';
		width: 320px;
	}
	.goods-box::after{
		content: '';
		width: 298px;
	}
	.tabbar::-webkit-scrollbar{
		display: none;
	}
	.txt-box::-webkit-scrollbar{
		  display: none;
	}
	.tct{
		text-align: center;
		text-indent: 0px;
	}
	.ntxt{
		text-align: left;
		text-indent: 30px;
	}
	.tdjs-list::-webkit-scrollbar {
		display: none;
	}
	.tdjs {
		width: 1370px;
		display: flex;
		padding: 10px;
		background: #e6e9ed;
	}
	.decoration-edit {
		width: 1370px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px;
		background: #e6e9ed;
		position: relative;

		.l,
		.r {
			width: 320px;
			height: 775px;
			background: #fff;
			border-radius: 10px;
			overflow-y: scroll;
		}

		.l {
			ul {
				margin: 0;
				padding: 0;

				li {
					width: 100%;
					min-height: 50px;
					cursor: default;
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					list-style: none;
					font-size: 14px;
					float: left;
					transition: all .3s;
					cursor: pointer;
					padding: 0 12px;
					font-weight: 600;
					box-sizing: border-box;

					&:hover {
						background: #efefef;
					}

					span {
						display: block;
						font-size: 40px;
						margin-bottom: 8px;
						color: #999;
					}

					p {
						display: block;
						margin: 0;
						font-size: 12px;
					}
				}
			}
		}

		.c {
			width: auto;
			max-width: 400px;
			position: relative;

			.top-nav {
				position: absolute;
				top: 0;
				background: #fff;
				z-index: 999;
				transition: all .3s;

				& * {
					pointer-events: none;
				}

				&:hover {
					transform: scale(0.95);
					border-radius: 10px;
					overflow: hidden;
					box-shadow: 0 0 10px #afafaf;
				}

				.tit {
					position: absolute;
					left: 50%;
					bottom: 20px;
					transform: translateX(-50%);
				}

				img {
					max-width: 100%;
					image-rendering: -moz-crisp-edges;
					image-rendering: -o-crisp-edges;
					image-rendering: -webkit-optimize-contrast;
					image-rendering: crisp-edges;
					-ms-interpolation-mode: nearest-neighbor;
				}
			}

			.view-content {
				width: 400px;
				height: 700px;
				background: #f5f5f5;
				overflow-y: auto;
				overflow-x: hidden;
				padding-top: 73px;
				box-shadow: 0 2px 6px #ccc;

				&::-webkit-scrollbar {
					width: 6px;
					display: none;
				}

				&::-webkit-scrollbar-thumb {
					background: #dbdbdb;
				}

				&::-webkit-scrollbar-track {
					background: #f6f6f6;
				}

				.item {
					transition: all .3s;
					cursor: pointer;

					&:hover {
						transform: scale(0.95);
						border-radius: 10px;
						box-shadow: 0 0 10px #afafaf;

						.el-icon-error {
							display: block;
						}
					}

					div {
						pointer-events: none;
					}

					.wait {
						background: #deedff;
						height: 35px;
						text-align: center;
						line-height: 35px;
						font-size: 12px;
						color: #666;
					}

					.el-icon-error {
						position: absolute;
						right: -10px;
						top: -6px;
						color: red;
						font-size: 25px;
						cursor: pointer;
						display: none;
						z-index: 9999;
					}
				}
			}
		}
		.submit-btn {
			position: absolute;
			bottom: 30px;
			left: 50%;
			transform: translateX(-50%);
		}
	}
</style>
